import React from "react";
export const PrepaidSims = () => {
  return (
    <>
      <svg
        width="1.4rem"
        height="1.4rem"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.93856 6.41675H8.66098C9.03665 6.41675 9.34115 6.74341 9.34115 7.14591V9.18758C9.34115 9.59008 9.03665 9.91675 8.6604 9.91675H5.93798C5.56231 9.91675 5.25781 9.59008 5.25781 9.18758V7.14591C5.25781 6.74341 5.56231 6.41675 5.93856 6.41675Z"
          stroke="#8B8BA7"
          strokeWidth="0.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6719 5.2325V11.0833C11.6719 11.7279 11.1498 12.25 10.5052 12.25H4.08854C3.44396 12.25 2.92188 11.7279 2.92188 11.0833V2.91667C2.92188 2.27208 3.44396 1.75 4.08854 1.75H8.26113C8.57671 1.75 8.87946 1.87775 9.09879 2.10467L11.3429 4.4205C11.554 4.63808 11.6719 4.92975 11.6719 5.2325Z"
          stroke="#8B8BA7"
          strokeWidth="0.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const splitCamelCase = (input) => {
  // Insert space before all capital letters and capitalize each word
  if (
    input === "ssn" ||
    input === "esnActivationDate" ||
    input === "adHocInvoiceAddedBy" ||
    input === "adHocInvoiceDate" ||
    input === "pwgCustomerId" ||
    input === "esnAssignDate" ||
    input === "esnActivatedBy" ||
    input === "imei" ||
    input === "esnNumber" ||
    input === "mdn" ||
    input === "accountId" ||
    input === "dob" ||
    input === "enrollmentId"
  ) {
    if (input === "adHocInvoiceAddedBy") {
      return "AD HOC Invoice Added By";
    } else if (input === "adHocInvoiceDate") {
      return "AD HOC Invoice Date";
    } else if (input === "esnActivationDate") {
      return "ESN Activation Date";
    } else if (input === "accountId") {
      return "Account ID";
    } else if (input === "ssn") {
      return "SSN";
    } else if (input === "mdn") {
      return "MDN";
    } else if (input === "imei") {
      return "IMEI";
    } else if (input === "esnNumber") {
      return "ESN Number";
    } else if (input === "pwgCustomerId") {
      return "PWG Customer ID";
    } else if (input === "esnAssignedDate") {
      return "ESN Assigned Date";
    } else if (input === "esnActivatedBy") {
      return "ESN Activated By";
    } else if (input === "dob") {
      return "DOB";
    } else {
      return "Enrollment ID";
    }
  } else {
    return input
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase
      .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2") // Handle all-caps to TitleCase transitions
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  }
};

export const CheckTickBtn = () => {
  return (
    <>
      <svg
        width="4rem"
        height="4rem"
        viewBox="0 0 57 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          width="5.6rem"
          height="5.6rem"
          fill="url(#pattern0_66_241)"
        />
        <defs>
          <pattern
            id="pattern0_66_241"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="0.1rem"
          >
            <use href="#image0_66_241" transform="scale(0.00195312)" />
          </pattern>
          <image
            id="image0_66_241"
            width="512"
            height="512"
            href="data:image/png;base64,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"
          />
        </defs>
      </svg>
    </>
  );
};
export const squareErrorMessages = {
  CARD_DECLINED: "Your card was declined. Please try a different card.",
  INSUFFICIENT_FUNDS: "There are insufficient funds in your account.",
  EXPIRED_CARD: "Your card has expired. Please use a different card.",
  INVALID_CVC: "The CVC code is incorrect. Please enter the correct code.",
  INVALID_ACCOUNT: "Your Square account is not authorized for payments.",
  CARD_NOT_SUPPORTED: "The card type you are using is not supported.",
  PROCESSING_ERROR:
    "There was an error processing the payment. Please try again.",
  FRAUDULENT:
    "Your transaction has been flagged as fraudulent. Please contact your bank.",
  NETWORK_ERROR:
    "A network error occurred. Please check your internet connection and try again.",
  GENERIC_ERROR: "An unknown error occurred. Please try again later.",
  INVALID_EXPIRATION:
    "The expiration date entered is invalid. Please check and try again.",
  INVALID_PAYMENT_METHOD:
    "The payment method is invalid. Please check the details and try again.",
  CARD_NOT_AUTHORIZED:
    "This card is not authorized for use. Please try a different card.",
  AUTHORIZATION_FAILED: "Authorization failed. Please try again later.",
  UNAUTHORIZED: "You are not authorized to perform this action.",
  INVALID_ACCESS_TOKEN: "The access token used for authentication is invalid.",
  PAYOUT_NOT_ALLOWED: "Payout operations are not allowed at this time.",
  TRANSACTION_LIMIT_EXCEEDED:
    "The transaction limit has been exceeded. Please try a smaller amount.",
  ACCOUNT_NOT_FOUND:
    "Square account not found. Please check your account details.",
  ACCOUNT_LOCKED: "Your Square account is locked. Please contact support.",
  ACCOUNT_CLOSED: "Your Square account has been closed.",
  SELLER_ACCOUNT_NOT_ENABLED:
    "Your Square account is not enabled for payments.",
  SELLER_ACCOUNT_DELETED: "Your Square account has been deleted.",
};

export const CheckFalseBtn = () => {
  return (
    <>
      <svg
        width="4.1rem"
        height="4rem"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="4rem" height="4rem" rx="20" fill="#B3261E" />
        <path
          d="M16.2524 24.2477L24.7477 15.7524"
          stroke="white"
          strokeWidth="1.20141"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.7477 24.2476L16.2524 15.7523"
          stroke="white"
          strokeWidth="1.20141"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Edit = () => {
  return (
    <>
      <svg
        width="1.8rem"
        height="1.8rem"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.96975 11.7149L11.7143 3.97035C12.0068 3.67785 12.4815 3.67785 12.774 3.97035L14.031 5.22735C14.3235 5.51985 14.3235 5.9946 14.031 6.2871L6.28575 14.0309C6.1455 14.1719 5.955 14.2506 5.75625 14.2506H3.75V12.2444C3.75 12.0456 3.82875 11.8551 3.96975 11.7149Z"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3125 5.37012L12.63 7.68762"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const EditHover = () => {
  return (
    <>
      <svg
        width="3.2rem"
        height="3.2rem"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="3.1rem"
          height="3.1rem"
          rx="3.5"
          fill="#475CED"
        />
        <rect
          x="0.5"
          y="0.5"
          width="3.1rem"
          height="3.1rem"
          rx="3.5"
          stroke="#475CED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.293 19.619L19.619 9.29299C20.009 8.90299 20.642 8.90299 21.032 9.29299L22.708 10.969C23.098 11.359 23.098 11.992 22.708 12.382L12.381 22.707C12.194 22.895 11.94 23 11.675 23H9V20.325C9 20.06 9.105 19.806 9.293 19.619Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.75 11.1602L20.84 14.2502"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Loginbg = () => {
  return (
    <>
      <svg
        width="1440"
        height="1024"
        viewBox="0 0 1440 1024"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_f_713_44372)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M973.268 115.703C1072.54 125.696 1183.12 78.0884 1267.05 132.055C1350.91 185.982 1362.16 301.756 1403.61 392.433C1441.17 474.589 1477.23 553.392 1499.68 640.893C1528.26 752.286 1624.5 885.471 1553.27 975.758C1477.43 1071.89 1308.62 978.787 1195.72 1026.19C1103.62 1064.86 1068.74 1189.89 973.268 1219.28C869.647 1251.17 755.428 1232.74 654.654 1192.75C545.744 1149.53 410.473 1096.69 379.563 983.669C346.949 864.418 499.722 764.458 503.729 640.893C507.528 523.732 373.591 424.595 401.384 310.715C428.861 198.129 533.549 106.668 643.238 69.2642C750.209 32.7871 860.817 104.384 973.268 115.703Z"
            fill="url(#paint0_linear_713_44372)"
            fillOpacity="0.3"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_713_44372"
            x="-63.9629"
            y="-379.963"
            width="2081.93"
            height="2054.43"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="219.481"
              result="effect1_foregroundBlur_713_44372"
            />
          </filter>
          <linearGradient
            id="paint0_linear_713_44372"
            x1="-163.798"
            y1="653.288"
            x2="956.686"
            y2="1799.96"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#E25544" />
            <stop offset="0.485" stop-color="#475CED" />
            <stop offset="1" stop-color="#620C90" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export const TeleyorkLogo = () => {
  return (
    <svg
      width="6rem"
      height="4.3rem"
      viewBox="0 0 71 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.6422 0.014801V39.5546C34.3717 39.1964 34.1451 38.9187 33.9551 38.6263C33.8746 38.502 33.8527 38.3339 33.8527 38.1804C33.8527 37.9245 33.8454 37.6687 33.8454 37.4055L33.8235 34.8543C33.8015 31.5282 33.7796 28.2022 33.765 24.8761C33.765 24.7738 33.7577 24.6715 33.7504 24.5691L32.515 22.4711V32.7783C32.1495 32.0984 31.5501 31.7037 31.5501 30.8703C31.5501 25.863 31.4989 20.8556 31.477 15.8483C31.477 15.7386 31.4697 15.629 31.4623 15.5266L30.4463 13.5895L30.3439 13.3921V26.3528L30.0808 25.9142C29.898 25.6656 29.7299 25.4098 29.6129 25.1247C29.5179 24.8908 29.4594 24.6349 29.4594 24.3352C29.4667 18.4726 29.4229 12.6173 29.4009 6.75463C29.4009 6.62305 29.4009 6.49147 29.4009 6.25755C28.7065 6.25755 28.0486 6.26486 27.398 6.25755C26.1553 6.23562 24.9126 6.18445 23.6699 6.16983C23.5017 6.16983 23.2898 6.25755 23.1728 6.37451C21.7547 7.79996 20.3511 9.24003 18.9257 10.6947C18.838 10.6143 18.7429 10.5339 18.6625 10.4535C15.8847 7.64645 13.1142 4.84672 10.3364 2.04698C9.89051 1.59376 9.43729 1.14785 8.99138 0.694632C8.94752 0.650772 8.91097 0.606912 8.88904 0.563052L8.32617 0.014801H15.1464L18.9038 3.5894L22.4126 0.014801H34.6422Z"
        fill="black"
      />
      <path
        d="M35.8118 0.0147421V39.5546C36.0822 39.1964 36.3088 38.9186 36.4989 38.6262C36.5793 38.5019 36.6012 38.3338 36.6012 38.1803C36.6012 37.9244 36.6086 37.6686 36.6086 37.4054L36.6305 34.8542C36.6524 31.5282 36.6743 28.2021 36.689 24.8761C36.689 24.7737 36.6963 24.6714 36.7036 24.5691L37.939 22.4711V32.7782C38.3045 32.0984 38.9039 31.7036 38.9039 30.8703C38.9039 25.8629 38.9551 20.8556 38.977 15.8482C38.977 15.7386 38.9843 15.6289 38.9916 15.5266L40.0077 13.5894L40.1101 13.3921V26.3527L40.3732 25.9141C40.556 25.6656 40.7241 25.4097 40.8411 25.1246C40.9361 24.8907 40.9946 24.6348 40.9946 24.3351C40.9873 18.4725 41.0311 12.6172 41.053 6.75457C41.053 6.62299 41.053 6.49141 41.053 6.25749C41.7475 6.25749 42.4054 6.2648 43.056 6.25749C44.2987 6.23556 45.5414 6.18439 46.7841 6.16977C46.9522 6.16977 47.1642 6.25749 47.2812 6.37445C48.6993 7.7999 50.1028 9.23997 51.5283 10.6947C51.616 10.6143 51.711 10.5338 51.7914 10.4534C54.5692 7.64639 57.3397 4.84666 60.1175 2.04692C60.5635 1.5937 61.0167 1.14779 61.4626 0.694573C61.5064 0.650713 61.543 0.606853 61.5649 0.562993L62.1132 0.00012207H55.2929L51.5356 3.57472L48.0414 0.0147421H35.8118Z"
        fill="black"
      />
      <path
        d="M49.2621 43.5021V44.8837C50.8265 45.1834 52.0034 46.5503 52.0034 48.1805C52.0034 49.8106 50.8192 51.1776 49.2621 51.4773V52.8589C51.594 52.5446 53.385 50.5709 53.385 48.1805C53.385 45.7901 51.594 43.8164 49.2621 43.5021ZM43.8235 48.1805C43.8235 50.5709 45.6144 52.5446 47.9463 52.8589V51.4773C46.382 51.1776 45.1978 49.8106 45.1978 48.1805C45.1978 46.543 46.382 45.1834 47.9463 44.8837V43.5021C45.6218 43.8164 43.8235 45.7901 43.8235 48.1805Z"
        fill="black"
      />
      <path
        d="M35.3732 43.831L38.7431 48.7579V52.4787H40.5487V48.831L37.2592 43.831H35.3732Z"
        fill="black"
      />
      <path
        d="M42.0472 43.831H43.8235L41.1115 47.8734L40.0588 46.5796L42.0472 43.831Z"
        fill="black"
      />
      <path
        d="M65.6877 48.9188L64.6205 50.0372V52.5007H62.9172V43.7287H64.6205V47.91L64.7009 47.8223L65.6877 48.9188Z"
        fill="black"
      />
      <path
        d="M68.3998 43.7287H70.3442L66.6965 47.8223L65.6219 46.7697L68.3998 43.7287Z"
        fill="black"
      />
      <path
        d="M68.6849 52.4423L70.4539 52.3399L67.5372 48.6484L66.5942 49.6937L68.6849 52.4423Z"
        fill="black"
      />
      <path d="M33.765 43.6847H27.3395V45.0005H33.765V43.6847Z" fill="black" />
      <path
        d="M33.7649 47.2155H27.3394V48.5313H33.7649V47.2155Z"
        fill="black"
      />
      <path
        d="M33.7649 51.0678H27.3394V52.3836H33.7649V51.0678Z"
        fill="black"
      />
      <path
        d="M15.7165 43.7287H9.29102V45.0445H15.7165V43.7287Z"
        fill="black"
      />
      <path
        d="M15.7165 47.2593H9.29102V48.5751H15.7165V47.2593Z"
        fill="black"
      />
      <path d="M15.7165 51.119H9.29102V52.4348H15.7165V51.119Z" fill="black" />
      <path
        d="M24.5398 50.9583H21.6377V52.4787H24.5398V50.9583Z"
        fill="black"
      />
      <path d="M6.8641 43.7287H0V45.2492H6.8641V43.7287Z" fill="black" />
      <path
        d="M61.2579 52.3472H59.2988L57.4128 49.4524H55.5999V52.3472H54.0795V48.0196H58.195C58.4655 48.0196 58.7286 47.9465 58.9479 47.793C59.3354 47.5226 59.5839 47.0766 59.5839 46.5723C59.5839 46.1702 59.4231 45.812 59.1672 45.5415C58.9552 45.3149 58.6482 45.198 58.3412 45.198H54.0721V43.6775H58.3339C59.1672 43.6775 59.9713 44.0576 60.4611 44.7301C60.5707 44.8763 60.6585 45.0298 60.7389 45.198C60.9216 45.5927 61.0313 46.0313 61.0313 46.5065C61.0313 47.062 60.8851 47.581 60.6292 48.0196C60.2783 48.6191 59.7301 49.0723 59.0795 49.2696L59.2111 49.4597L61.2579 52.3472Z"
        fill="black"
      />
      <path
        d="M20.1464 43.6848H18.4578V52.4787H20.1464V43.6848Z"
        fill="black"
      />
      <path
        d="M4.07177 46.6307H2.74866V52.2668H4.07177V46.6307Z"
        fill="black"
      />
    </svg>
  );
};
export const SniptelLogin = () => {
  return (
    <>
      <svg
        width="4rem"
        height="3.2rem"
        viewBox="0 0 40 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9566 3.39497C19.0884 3.01324 20.278 6.24361 17.7992 7.12145C14.737 7.84138 11.7474 8.33439 7.91702 11.4491C8.68335 12.2219 9.44967 12.9947 10.2166 13.7675C16.2201 9.33969 23.4093 9.24208 29.5768 12.8573C28.6052 13.8246 27.6343 14.792 26.6633 15.7594C22.4962 13.64 17.151 13.308 12.1648 17.3907C10.9887 18.6951 9.82457 18.9232 8.61917 17.9061C6.84061 16.1716 5.06206 14.437 3.2835 12.7025C2.62901 11.7979 2.6449 10.8933 3.44172 9.98937C7.22886 6.38598 11.7188 4.15842 16.9572 3.39497H16.9566Z"
          fill="#475CED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.439 7.17507C21.3859 6.39608 21.6744 3.98138 23.5972 3.32797C26.7051 3.12903 34.0722 6.03735 37.8676 10.2146C38.5488 10.9339 38.5729 11.8826 37.8676 12.6877C32.6075 17.8628 27.3481 23.0378 22.0881 28.2122C19.9721 29.8187 17.5549 27.4817 18.9459 25.6017C23.7433 20.8904 28.5414 16.1792 33.3389 11.4679C30.409 9.17384 27.1645 7.61399 23.439 7.17445V7.17507Z"
          fill="#475CED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.1119 18.2139C22.9942 19.3075 21.8772 20.4005 20.7594 21.494C19.2223 21.3504 17.8295 21.9124 16.5733 23.1428C14.4598 24.8083 12.3794 21.9379 13.7386 20.4297C16.8287 17.5568 20.2962 16.8742 24.1119 18.2146V18.2139Z"
          fill="#475CED"
        />
      </svg>
    </>
  );
};
export const Sniptel = () => {
  return (
    <>
      <svg
        width="145"
        height="88"
        viewBox="0 0 145 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66.7179 0.122377C69.9728 -0.471931 71.7892 4.56287 68.0042 5.9309C63.3284 7.05348 58.7636 7.82097 52.9151 12.6764C54.0853 13.8812 55.2555 15.0847 56.4257 16.2896C65.5927 9.38835 76.5698 9.23635 85.9876 14.8704C84.5042 16.378 83.0222 17.8856 81.5388 19.3944C75.1763 16.0914 67.0149 15.5731 59.4011 21.9373C57.6059 23.9695 55.8281 24.3258 53.9867 22.7397C51.2708 20.0361 48.5549 17.3324 45.839 14.63C44.8397 13.2196 44.8646 11.8104 46.0798 10.4013C51.8621 4.78589 58.7187 1.31349 66.7167 0.123623L66.7179 0.122377Z"
          fill="#475CED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.6179 6.01041C73.4828 4.79563 73.9231 1.03292 76.8586 0.0150007C81.6043 -0.295236 92.8534 4.23745 98.6483 10.7487C99.6888 11.87 99.7262 13.3489 98.6483 14.6036C90.6166 22.6697 82.5861 30.7346 74.5544 38.8008C71.3233 41.3038 67.633 37.662 69.7563 34.7328C77.0819 27.3893 84.4075 20.047 91.7332 12.7035C87.2594 9.12772 82.3054 6.69692 76.6179 6.01166V6.01041Z"
          fill="#475CED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M77.6508 23.2082C75.9442 24.9127 74.2375 26.6171 72.5321 28.3203C70.1855 28.096 68.0584 28.9719 66.1397 30.8894C62.9123 33.4847 59.736 29.0118 61.8107 26.6607C66.5289 22.1828 71.8235 21.1188 77.6508 23.2082Z"
          fill="#475CED"
        />
        <path
          d="M0 56.2286C0 54.8917 0.2545 53.6396 0.761004 52.4646C1.27624 51.2972 1.96863 50.2755 2.84566 49.3922C3.72268 48.5163 4.75316 47.8248 5.92211 47.3102C7.09106 46.8031 8.35234 46.5502 9.68347 46.5502H24.5131V53.0104H9.68347C9.2381 53.0104 8.81393 53.0876 8.4222 53.2571C8.02922 53.4178 7.69113 53.6495 7.39921 53.9411C7.10728 54.2326 6.87649 54.579 6.7143 54.9627C6.54589 55.354 6.4598 55.7763 6.4598 56.2298C6.4598 56.6759 6.54464 57.0983 6.7143 57.497C6.87524 57.8969 7.10728 58.242 7.39921 58.5336C7.69113 58.8264 8.02922 59.0556 8.4222 59.2176C8.81393 59.387 9.2381 59.4643 9.68347 59.4643H16.152C17.4906 59.4643 18.7519 59.7184 19.9283 60.2243C21.1048 60.7239 22.1365 61.4154 23.0135 62.2913C23.8905 63.1672 24.5817 64.1963 25.0907 65.3712C25.591 66.5536 25.8442 67.807 25.8442 69.1426C25.8442 70.4795 25.5897 71.7317 25.0907 72.9066C24.5829 74.074 23.8905 75.0957 23.0135 75.9716C22.1365 76.8549 21.106 77.5464 19.9283 78.0535C18.7519 78.5681 17.4906 78.821 16.152 78.821H1.80021V72.3609H16.152C16.6061 72.3609 17.0215 72.2762 17.4133 72.1154C17.805 71.9472 18.1431 71.723 18.4438 71.4314C18.7357 71.1399 18.959 70.7935 19.1274 70.4023C19.2896 70.0185 19.3732 69.5962 19.3732 69.1426C19.3732 68.6966 19.2883 68.2742 19.1274 67.883C18.959 67.4905 18.7357 67.1529 18.4438 66.8614C18.1431 66.5698 17.805 66.3393 17.4133 66.1773C17.0203 66.0091 16.6049 65.9232 16.152 65.9232H9.68347C8.35234 65.9232 7.09106 65.6702 5.92211 65.1632C4.75316 64.6486 3.72268 63.9571 2.84566 63.0812C1.96863 62.1978 1.27624 61.1762 0.761004 59.9938C0.253252 58.8189 0 57.558 0 56.2298L0 56.2286ZM35.3505 78.8198H29.2051V54.7148H30.6897L32.7207 57.0571C33.7125 56.1588 34.8353 55.4599 36.0891 54.9752C37.3429 54.4918 38.6503 54.2451 40.0201 54.2451C41.4885 54.2451 42.882 54.5217 44.1894 55.0911C45.4968 55.6517 46.6358 56.4205 47.6127 57.4035C48.5895 58.3865 49.358 59.539 49.9281 60.8522C50.4895 62.1654 50.7665 63.5634 50.7665 65.046V78.8185H44.6211V65.046C44.6211 64.4168 44.4976 63.8163 44.2593 63.2556C44.0135 62.695 43.6904 62.2028 43.2675 61.7805C42.8446 61.3656 42.3605 61.0354 41.7991 60.7899C41.2452 60.552 40.6526 60.4286 40.0226 60.4286C39.3764 60.4286 38.7688 60.552 38.1999 60.7899C37.6236 61.0354 37.1308 61.3656 36.7079 61.7805C36.2924 62.2028 35.9618 62.695 35.7161 63.2556C35.4778 63.8163 35.3543 64.4156 35.3543 65.046V78.8185L35.3505 78.8198ZM62.3949 48.1699C62.3949 48.7393 62.2876 49.2688 62.0718 49.7685C61.8484 50.2606 61.5565 50.6904 61.1798 51.058C60.803 51.4268 60.3639 51.7183 59.8574 51.9339C59.3571 52.1569 58.8194 52.2641 58.2505 52.2641C57.6816 52.2641 57.1427 52.1569 56.6437 51.9339C56.1359 51.7183 55.698 51.4268 55.3363 51.058C54.967 50.6892 54.675 50.2594 54.4517 49.7685C54.2359 49.2688 54.1286 48.7393 54.1286 48.1699C54.1286 47.6093 54.2359 47.0872 54.4517 46.5801C54.675 46.0805 54.967 45.6432 55.3363 45.2744C55.698 44.9056 56.1359 44.614 56.6437 44.3985C57.1439 44.183 57.6816 44.0758 58.2505 44.0758C58.8194 44.0758 59.3583 44.183 59.8574 44.3985C60.3651 44.614 60.8043 44.9056 61.1798 45.2744C61.5565 45.6432 61.8497 46.0805 62.0718 46.5801C62.2876 47.0872 62.3949 47.6093 62.3949 48.1699ZM61.3332 78.8198H55.1416V54.7148H61.3332V78.8198ZM72.2168 87.9998H66.0252V54.7148H67.5098L69.9638 57.6191C70.5251 57.097 71.1327 56.5974 71.7939 56.1364C72.4551 55.6679 73.14 55.268 73.8549 54.9303C74.5697 54.5927 75.3083 54.331 76.0705 54.1317C76.839 53.9398 77.6162 53.8389 78.3934 53.8389C80.0926 53.8389 81.6857 54.1466 83.1853 54.7534C84.6773 55.3602 85.9848 56.2199 87.1001 57.3263C88.2229 58.4401 89.1074 59.777 89.7536 61.3431C90.3998 62.9105 90.723 64.6461 90.723 66.5511C90.723 68.5334 90.3998 70.3151 89.7536 71.8974C89.1074 73.4797 88.2229 74.8241 87.1001 75.923C85.9848 77.0294 84.6773 77.8741 83.1853 78.4585C81.6857 79.0415 80.0926 79.3343 78.3934 79.3343C77.8545 79.3343 77.3168 79.2808 76.7853 79.1574C76.2477 79.0341 75.7237 78.8734 75.2084 78.674C74.6857 78.4747 74.178 78.2442 73.6702 77.99C73.17 77.7283 72.6859 77.4679 72.2168 77.1988V87.9985V87.9998ZM84.5463 66.5524C84.5463 65.5382 84.3842 64.6162 84.0623 63.8101C83.7392 62.9952 83.3013 62.3125 82.7474 61.7518C82.186 61.1911 81.5323 60.7538 80.7862 60.4535C80.0327 60.1545 79.233 60.0087 78.3947 60.0087C77.5563 60.0087 76.7641 60.1545 76.0181 60.4535C75.2721 60.7538 74.6258 61.1911 74.0719 61.7518C73.5105 62.3125 73.0726 62.9965 72.7495 63.8101C72.4264 64.6162 72.2655 65.5382 72.2655 66.5524C72.2655 67.5279 72.4264 68.4188 72.7495 69.2336C73.0726 70.0397 73.5105 70.7312 74.0719 71.3006C74.6258 71.8775 75.2721 72.3148 76.0181 72.6288C76.7641 72.944 77.5563 73.1047 78.3947 73.1047C79.233 73.1047 80.0327 72.944 80.7862 72.6288C81.5323 72.3135 82.186 71.8762 82.7474 71.3006C83.3013 70.7325 83.7392 70.041 84.0623 69.2336C84.3854 68.4188 84.5463 67.5292 84.5463 66.5524ZM106.044 78.8198C104.56 78.8198 103.16 78.5357 101.852 77.975C100.545 77.4144 99.3984 76.6382 98.4141 75.6551C97.4298 74.6721 96.66 73.5271 96.0912 72.2288C95.5298 70.9231 95.2528 69.5239 95.2528 68.0425V60.8834H92.2524V54.7609H95.2528V45.1274H101.383V54.7609H110.706V60.8834H101.383V68.0425C101.383 68.6879 101.499 69.2872 101.738 69.8553C101.983 70.416 102.314 70.9081 102.729 71.323C103.152 71.7454 103.645 72.083 104.221 72.3285C104.792 72.5752 105.398 72.6973 106.044 72.6973H110.705V78.8198H106.044ZM144.571 78.8198H138.379V45.1274H144.571V78.8198Z"
          fill="#475CED"
        />
        <path
          d="M123.758 72.9204C123.996 72.9976 124.235 73.0512 124.481 73.0661C124.719 73.0886 124.957 73.1048 125.195 73.1048C125.795 73.1048 126.381 73.0201 126.934 72.8593C127.488 72.6899 128.011 72.4519 128.495 72.1442C128.988 71.8377 129.426 71.4614 129.803 71.0228C130.187 70.578 130.502 70.0859 130.741 69.5476L135.248 74.0716C134.678 74.8777 134.017 75.6078 133.278 76.2532C132.532 76.8986 131.725 77.4443 130.863 77.8966C130.002 78.3414 129.094 78.6878 128.141 78.9183C127.186 79.1488 126.202 79.2721 125.194 79.2721C123.502 79.2721 121.902 78.9569 120.41 78.3277C118.91 77.6985 117.603 76.8139 116.487 75.6926C115.363 74.5625 114.488 73.2269 113.841 71.6757C113.195 70.1233 112.872 68.4188 112.872 66.5512C112.872 64.6462 113.195 62.9106 113.841 61.3357C114.488 59.7609 115.365 58.4165 116.487 57.3027C117.603 56.1963 118.91 55.3279 120.41 54.7136C121.902 54.0994 123.502 53.7916 125.194 53.7916C126.202 53.7916 127.186 53.915 128.148 54.1529C129.11 54.3909 130.025 54.736 130.887 55.1896C131.747 55.6344 132.556 56.1888 133.309 56.8417C134.063 57.4945 134.724 58.2246 135.293 59.0382L123.756 72.9191L123.758 72.9204ZM126.912 60.253C126.628 60.1459 126.343 60.0848 126.066 60.0537C125.789 60.0238 125.497 60.0076 125.197 60.0076C124.358 60.0076 123.566 60.1608 122.82 60.4686C122.081 60.7763 121.435 61.2136 120.881 61.7818C120.335 62.3512 119.905 63.0414 119.589 63.84C119.273 64.6462 119.112 65.5457 119.112 66.5512C119.112 66.7817 119.129 67.0346 119.151 67.3199C119.173 67.604 119.205 67.8955 119.26 68.1871C119.313 68.4786 119.374 68.7552 119.452 69.0318C119.529 69.301 119.629 69.5389 119.745 69.747L126.913 60.2518L126.912 60.253Z"
          fill="#475CED"
        />
      </svg>
    </>
  );
};
export const Eyebutton = () => {
  return (
    <svg
      width="1.6rem"
      height="1.7rem"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.70416 9.53833C9.27779 10.2572 8.44964 10.6356 7.62707 10.4872C6.80451 10.3389 6.1607 9.69506 6.01235 8.8725C5.864 8.04993 6.24233 7.22178 6.96124 6.79541"
        stroke="#72728F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9963 11.8309C10.8464 12.703 9.44179 13.1731 7.99858 13.1687C5.60718 13.2113 3.39761 11.897 2.29354 9.7753C1.89694 8.97142 1.89694 8.02878 2.29354 7.2249C2.84571 6.12531 3.72591 5.22447 4.8124 4.64697"
        stroke="#72728F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6165 9.92318C13.6433 9.87249 13.6781 9.82703 13.7034 9.77537C14.1 8.9715 14.1 8.02886 13.7034 7.22498C12.5993 5.10326 10.3898 3.78898 7.99835 3.83157C7.84843 3.83157 7.7027 3.85158 7.55469 3.86133"
        stroke="#72728F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0021 13.8356L2.66406 2.49756"
        stroke="#72728F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Continue = () => {
  return (
    <>
      <svg
        width="1.8rem"
        height="1.8rem"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.96975 11.7144L11.7143 3.96986C12.0068 3.67736 12.4815 3.67736 12.774 3.96986L14.031 5.22686C14.3235 5.51936 14.3235 5.99411 14.031 6.28661L6.28575 14.0304C6.1455 14.1714 5.955 14.2501 5.75625 14.2501H3.75V12.2439C3.75 12.0451 3.82875 11.8546 3.96975 11.7144Z"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3125 5.36987L12.63 7.68737"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Editbutton = () => {
  return (
    <>
      <svg
        width="1.8rem"
        height="1.8rem"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.96975 11.7144L11.7143 3.96986C12.0068 3.67736 12.4815 3.67736 12.774 3.96986L14.031 5.22686C14.3235 5.51936 14.3235 5.99411 14.031 6.28661L6.28575 14.0304C6.1455 14.1714 5.955 14.2501 5.75625 14.2501H3.75V12.2439C3.75 12.0451 3.82875 11.8546 3.96975 11.7144Z"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3125 5.36987L12.63 7.68737"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FreeIcon = () => {
  return (
    <>
      <svg
        width="5.3rem"
        height="5.6rem"
        viewBox="0 0 53 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.8707 43.61L39.0608 39.51C39.5496 39.2239 40.3495 38.0393 40.95 37.1499C41.1949 36.7872 41.4067 36.4736 41.5507 36.29V49.22C41.5469 51.0187 40.83 52.7426 39.5572 54.0135C38.2843 55.2845 36.5594 55.9989 34.7607 56H7.7607C5.96197 55.9988 4.23709 55.2845 2.96426 54.0135C1.69142 52.7426 0.97451 51.0187 0.970703 49.22V6.79C0.97411 4.99023 1.69058 3.26514 2.96321 1.99251C4.23585 0.719874 5.96093 0.00340696 7.7607 0H27.9707V7.57C27.9737 9.16039 28.6067 10.6848 29.7313 11.8094C30.8559 12.934 32.3803 13.567 33.9707 13.57H41.5507V16.41L33.4307 28H6.2707C6.00828 28.0042 5.75804 28.1115 5.57395 28.2985C5.38987 28.4856 5.2867 28.7375 5.2867 29C5.2867 29.2625 5.38987 29.5144 5.57395 29.7015C5.75804 29.8885 6.00828 29.9958 6.2707 30H32.0307L30.4706 32.2299C30.0975 32.7071 29.7883 34.1109 29.5642 35.1287C29.4856 35.4854 29.4175 35.7946 29.3607 36H6.2708C6.00827 36.0041 5.75786 36.1112 5.57364 36.2983C5.38942 36.4854 5.28615 36.7374 5.28615 37C5.28614 37.2625 5.38938 37.5146 5.5736 37.7017C5.75781 37.8888 6.00821 37.9959 6.27074 38H28.8807L28.2907 40.4299C28.1545 41.015 28.1971 41.6276 28.413 42.1882C28.6288 42.7488 29.008 43.2317 29.5015 43.5743C29.995 43.9169 30.5799 44.1035 31.1806 44.1099C31.7813 44.1162 32.3701 43.9421 32.8707 43.61ZM21.2708 12H6.27075C6.00822 12.0041 5.75782 12.1112 5.5736 12.2983C5.38938 12.4854 5.28613 12.7374 5.28613 13C5.28613 13.2626 5.38938 13.5146 5.5736 13.7017C5.75782 13.8888 6.00822 13.9959 6.27075 14H21.2707C21.5332 13.9959 21.7836 13.8888 21.9679 13.7017C22.1521 13.5146 22.2553 13.2626 22.2554 13C22.2554 12.7375 22.1521 12.4854 21.9679 12.2983C21.7837 12.1112 21.5333 12.0041 21.2708 12ZM25.2608 20H6.27075C6.00822 20.0041 5.75782 20.1112 5.5736 20.2983C5.38938 20.4854 5.28613 20.7374 5.28613 21C5.28613 21.2626 5.38938 21.5146 5.5736 21.7017C5.75782 21.8888 6.00822 21.9959 6.27075 22H25.2607C25.5232 21.9959 25.7736 21.8888 25.9579 21.7017C26.1421 21.5146 26.2453 21.2626 26.2453 21C26.2454 20.7375 26.1421 20.4854 25.9579 20.2983C25.7737 20.1112 25.5233 20.0041 25.2608 20ZM23.1608 47.86L25.8508 45.92C25.9571 45.8425 26.0471 45.7449 26.1157 45.6326C26.1844 45.5203 26.2302 45.3956 26.2506 45.2656C26.2711 45.1356 26.2657 45.0028 26.2348 44.8749C26.2039 44.747 26.1482 44.6264 26.0707 44.52C25.9932 44.4136 25.8955 44.3236 25.7832 44.2549C25.671 44.1863 25.5462 44.1405 25.4162 44.1201C25.2862 44.0996 25.1535 44.105 25.0256 44.1359C24.8976 44.1668 24.7771 44.2225 24.6707 44.3L22.2607 46.04C22.2631 45.6776 22.1583 45.3225 21.9595 45.0194C21.7607 44.7164 21.4767 44.4789 21.1433 44.3367C20.8099 44.1946 20.4419 44.1542 20.0856 44.2206C19.7293 44.287 19.4006 44.4572 19.1408 44.7099L18.2208 45.63C18.1508 45.3094 17.9963 45.0134 17.7732 44.7727C17.5501 44.5321 17.2665 44.3556 16.9521 44.2617C16.6377 44.1677 16.3038 44.1598 15.9853 44.2386C15.6667 44.3174 15.3751 44.4802 15.1408 44.7099L14.2607 45.59C14.2839 45.258 14.2172 44.926 14.0676 44.6287C13.9181 44.3315 13.6911 44.08 13.4106 43.9009C13.1302 43.7218 12.8066 43.6216 12.474 43.6109C12.1414 43.6002 11.8121 43.6793 11.5207 43.84L5.7807 47.13C5.5937 47.2419 5.44807 47.4115 5.3657 47.6133C5.28333 47.815 5.26867 48.0381 5.32391 48.2489C5.37916 48.4597 5.50133 48.6469 5.67207 48.7824C5.84281 48.9178 6.0529 48.9942 6.27075 49C6.18286 49.2559 9.05696 47.5804 10.8556 46.5319C11.6434 46.0727 12.2248 45.7337 12.2608 45.73L12.2608 46C12.2656 46.3593 12.3756 46.7093 12.5774 47.0067C12.7791 47.3041 13.0636 47.5358 13.3957 47.6731C13.7278 47.8104 14.0928 47.8473 14.4457 47.7792C14.7985 47.7111 15.1236 47.541 15.3808 47.29L16.3008 46.38C16.3724 46.6996 16.5281 46.9942 16.7519 47.2334C16.9756 47.4725 17.2592 47.6476 17.5733 47.7404C17.8873 47.8332 18.2205 47.8404 18.5383 47.7612C18.8561 47.682 19.1469 47.5193 19.3808 47.29L20.2608 46.4099C20.2699 46.7426 20.3692 47.0666 20.5481 47.3473C20.7269 47.628 20.9786 47.8549 21.2763 48.0037C21.574 48.1526 21.9066 48.2178 22.2384 48.1925C22.5703 48.1672 22.8891 48.0523 23.1608 47.86ZM40.9507 11.5701H33.9707C32.9103 11.5687 31.8937 11.1468 31.1438 10.3969C30.394 9.64711 29.9721 8.63051 29.9707 7.57008V0.580078L40.9507 11.5701ZM45.4507 14.3301L46.2807 13.1501C46.8479 12.359 47.7042 11.8234 48.6637 11.6596C49.6233 11.4958 50.6087 11.7168 51.4063 12.2749C52.2039 12.833 52.7493 13.683 52.9243 14.6406C53.0992 15.5981 52.8895 16.5861 52.3407 17.3901L51.5107 18.5701C50.6741 17.9827 49.6238 17.2489 48.5673 16.5108C47.4545 15.7333 46.3348 14.9511 45.4507 14.3301ZM30.2408 40.8701C30.2407 40.8701 31.7044 34.7822 31.9607 33.7201C31.8376 33.6971 37.4797 25.6744 41.4344 20.0509C42.6 18.3934 43.6191 16.9444 44.3007 15.9701C45.1757 16.5859 46.2688 17.3489 47.36 18.1106C48.4316 18.8587 49.5013 19.6055 50.3607 20.2101C49.3303 21.6403 47.6179 24.1073 45.755 26.7911C42.8219 31.0165 39.5158 35.7794 37.9109 37.8802L31.7708 41.9401C31.6024 42.048 31.4057 42.1035 31.2057 42.0994C31.0057 42.0953 30.8115 42.032 30.6475 41.9173C30.4836 41.8027 30.3575 41.642 30.285 41.4555C30.2126 41.2691 30.1972 41.0653 30.2408 40.8701Z"
          fill="#C68301"
        />
      </svg>
    </>
  );
};

export const InuseIcon = () => {
  return (
    <>
      <svg
        width="5.4rem"
        height="5.4rem"
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M49.0533 4.18468H40.4737V2.73174C40.4737 2.38728 40.1919 2.10547 39.8474 2.10547C39.5029 2.10547 39.2211 2.38728 39.2211 2.73174V4.18468H30.6414C29.0759 4.18468 27.8045 5.456 27.8045 7.02158V18.0247C27.8045 19.5903 29.0759 20.8616 30.6414 20.8616H39.2211V25.4206C38.1753 25.0574 36.9978 25.3267 36.2465 26.1722C30.059 33.0734 25.5564 37.8142 24.6671 38.3715H8.7166C5.07182 38.3715 2.10962 41.2711 2.10962 44.8344V51.2661C2.10962 51.6106 2.3851 51.8924 2.73589 51.8924H30.7543C31.0988 51.8924 31.3806 51.6106 31.3806 51.2661V44.9161C31.775 43.9266 36.3342 36.3552 40.4924 29.598C41.175 28.333 41.1563 27.187 40.4737 26.3228V20.8618H49.0533C50.6189 20.8618 51.8902 19.5905 51.8902 18.0249V7.02158C51.8904 5.456 50.6191 4.18468 49.0533 4.18468ZM39.4093 28.9717C30.1282 44.0519 30.1282 44.5967 30.1282 44.8347V50.6401H3.36217V44.8347C3.36217 41.9602 5.76074 39.6243 8.7166 39.6243H24.7799C25.187 39.6243 25.8696 39.6243 37.1797 27.0054C37.6619 26.473 38.4885 26.354 39.096 26.7299C39.7662 27.1743 40.0355 27.8194 39.4093 28.9717ZM45.008 10.0089L38.9458 15.9333C38.7016 16.1712 38.3135 16.1712 38.0753 15.9333L35.8145 13.7288C35.5702 13.4908 35.5641 13.09 35.802 12.8458C36.0463 12.5952 36.4408 12.5952 36.6913 12.8333L38.5138 14.612L44.1376 9.11345C44.3819 8.86918 44.7764 8.87551 45.0206 9.11977C45.2647 9.37016 45.2584 9.76461 45.008 10.0089Z"
          fill="#7270D1"
        />
        <path
          d="M24.1287 25.1658C24.1287 30.42 20.5466 36.2942 15.7557 36.2942C10.9586 36.2942 7.37646 30.42 7.37646 25.1658C7.37646 21.6463 10.9586 17.707 15.7557 17.707C20.5466 17.7072 24.1287 21.6463 24.1287 25.1658Z"
          fill="#7270D1"
        />
      </svg>
    </>
  );
};

export const StockIcon = () => {
  return (
    <>
      <svg
        width="5.1rem"
        height="5.6rem"
        viewBox="0 0 51 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.7511 6.08996C35.8496 6.0343 35.9481 5.97863 36.0451 5.92154C35.4456 5.60183 34.8462 5.28783 34.2467 4.97382C32.2542 3.91763 30.2674 2.86715 28.275 1.81666C27.9785 1.65951 27.6832 1.50012 27.3879 1.34077C26.7392 0.990691 26.0909 0.640792 25.4318 0.315158C25.0926 0.15068 24.8412 0.28699 24.5654 0.436623C24.5348 0.453193 24.504 0.469926 24.4727 0.486433C24.2271 0.6149 23.9816 0.744794 23.7361 0.874689C23.4906 1.00456 23.2452 1.13443 22.9997 1.26288C21.1956 2.2163 19.3858 3.16973 17.576 4.12316C15.2809 5.33921 12.9916 6.54955 10.6965 7.75988C9.65474 8.31073 8.61156 8.86158 7.56838 9.41242C6.52487 9.96344 5.48135 10.5145 4.43927 11.0655C3.87412 11.3652 3.30897 11.6635 2.74381 11.9617C2.17856 12.2601 1.6133 12.5584 1.04804 12.8582C0.990946 12.8867 0.939564 12.9152 0.888182 12.9438C0.517087 13.1436 0.517087 13.7374 0.888182 13.9315L3.28602 15.1989C4.24515 15.7042 5.20286 16.2108 6.16056 16.7175C7.11827 17.2242 8.07599 17.7309 9.03513 18.2362C9.9486 18.7157 10.8678 19.201 11.7812 19.6863C11.8783 19.6292 11.9753 19.5735 12.0724 19.5179C12.1695 19.4622 12.2665 19.4065 12.3636 19.3495C12.4391 19.3072 12.5146 19.2642 12.5905 19.2209C12.7096 19.153 12.8295 19.0846 12.9516 19.0183C13.0592 18.9588 13.1665 18.8995 13.2737 18.8402C13.7526 18.5756 14.2285 18.3126 14.7043 18.0421L14.7057 18.0413C16.8747 16.8084 19.0437 15.5755 21.2185 14.3425C22.4746 13.6288 23.7307 12.9165 24.9868 12.2043C26.2427 11.4921 27.4986 10.78 28.7545 10.0664C29.7737 9.48685 30.7929 8.90874 31.8121 8.33064C32.8311 7.75264 33.85 7.17464 34.869 6.59522C34.9032 6.5724 34.9432 6.54958 34.9831 6.52677L34.9832 6.52671C35.0631 6.48104 35.1416 6.43679 35.2201 6.39255C35.2986 6.3483 35.3771 6.30405 35.4571 6.25838C35.5541 6.20129 35.6526 6.14562 35.7511 6.08996ZM49.3303 13.9258C49.5529 13.8059 49.6329 13.6232 49.6157 13.4348C49.6329 13.2464 49.5529 13.058 49.336 12.9324L46.9382 11.6649C45.9789 11.1596 45.021 10.6528 44.0631 10.146C43.1056 9.63945 42.148 9.13285 41.189 8.62768L41.1888 8.62756C40.2754 8.14803 39.362 7.6685 38.4487 7.18326C38.3516 7.24035 38.2545 7.29602 38.1575 7.35168C38.0604 7.40735 37.9634 7.46301 37.8663 7.5201C37.6722 7.63428 37.4781 7.74847 37.2783 7.85694C36.6902 8.18236 36.1022 8.50778 35.5199 8.83891L35.518 8.84C33.3491 10.0728 31.1803 11.3056 29.0057 12.5384C27.7497 13.2521 26.4937 13.9643 25.2377 14.6765C23.9817 15.3887 22.7257 16.1009 21.4697 16.8146C20.4534 17.3912 19.4358 17.9693 18.4181 18.5473C17.4005 19.1254 16.3828 19.7034 15.3666 20.28C15.3371 20.3011 15.3045 20.3191 15.2734 20.3362C15.2623 20.3423 15.2515 20.3483 15.241 20.3543C15.1639 20.3971 15.0869 20.4413 15.0098 20.4855C14.9327 20.5298 14.8556 20.5741 14.7785 20.6169C14.6815 20.674 14.583 20.7296 14.4845 20.7853C14.386 20.841 14.2875 20.8966 14.1905 20.9537C14.6319 21.1914 15.0764 21.4259 15.5194 21.6596C15.6724 21.7403 15.8251 21.8209 15.9775 21.9014C16.9737 22.4267 17.9685 22.9533 18.9633 23.48C19.9581 24.0067 20.9529 24.5333 21.9492 25.0586C22.298 25.2414 22.6452 25.4288 22.9925 25.6163C23.5891 25.9383 24.1862 26.2606 24.7924 26.5601C25.1316 26.7246 25.3829 26.5883 25.6588 26.4386C25.6894 26.4221 25.7202 26.4053 25.7515 26.3888C25.997 26.2604 26.2424 26.1305 26.4879 26.0007C26.7334 25.8708 26.9789 25.7409 27.2245 25.6124C28.565 24.8997 29.9088 24.1901 31.251 23.4814C31.715 23.2363 32.1789 22.9914 32.6425 22.7464C33.79 22.1412 34.9361 21.5346 36.0822 20.928C37.2283 20.3214 38.3744 19.7148 39.522 19.1097C40.5642 18.5586 41.6079 18.0074 42.6516 17.4563C43.6946 16.9056 44.7376 16.3548 45.7792 15.8041C46.909 15.2106 48.0388 14.6115 49.1687 14.0123L49.1704 14.0114C49.2275 13.9829 49.2788 13.9543 49.3302 13.9258L49.3303 13.9258ZM50.161 17.1343C50.1624 17.1414 50.1638 17.1486 50.1638 17.1571C50.1921 17.8794 50.1861 18.6046 50.1802 19.3245C50.1777 19.6232 50.1753 19.9209 50.1753 20.2172V42.3687C50.1753 42.5571 50.101 42.7455 49.8841 42.8597C49.8727 42.8654 49.8441 42.8768 49.8327 42.8826C49.2148 43.2482 48.5712 43.5787 47.9288 43.9085C47.568 44.0937 47.2077 44.2788 46.8525 44.4697C44.8201 45.5601 42.7876 46.6449 40.7552 47.7296L33.6987 51.4977C32.7225 52.02 31.7463 52.5409 30.7701 53.0618C29.7938 53.5828 28.8174 54.1038 27.8411 54.6263C27.4357 54.8432 27.0289 55.0602 26.6222 55.2771C26.2154 55.4941 25.8086 55.711 25.4033 55.928C25.329 55.9679 25.2434 55.9908 25.1635 55.9965H25.1521C25.0493 56.0079 24.9408 55.9908 24.8266 55.928C24.8224 55.9258 24.8181 55.9229 24.8136 55.9198C24.8059 55.9145 24.7974 55.9087 24.7867 55.9051C24.1109 55.5653 23.443 55.202 22.7741 54.8382C22.454 54.6641 22.1337 54.4898 21.8122 54.318C20.3044 53.509 18.7934 52.7032 17.284 51.8982C16.7588 51.6181 16.2338 51.3381 15.7091 51.0581L8.65262 47.29C7.67635 46.7676 6.70007 46.2467 5.7238 45.7257C4.74755 45.2047 3.77129 44.6838 2.79504 44.1614C1.97863 43.7275 1.16222 43.2936 0.351525 42.8597C0.174541 42.7684 0.0660676 42.5628 0.0660676 42.3687C0.0660676 42.3602 0.0646403 42.353 0.0632129 42.3459C0.0617855 42.3388 0.0603581 42.3316 0.0603581 42.3231C0.0321266 41.6011 0.0380839 40.8764 0.0440149 40.1548C0.0464797 39.8549 0.04894 39.5556 0.04894 39.2572V17.1115C0.04894 16.6662 0.539927 16.4207 0.91673 16.6205C0.922439 16.6233 0.93243 16.6276 0.942421 16.6319C0.952412 16.6362 0.962403 16.6405 0.968113 16.6433C1.66808 16.9953 2.35964 17.3725 3.05065 17.7494C3.34595 17.9105 3.64116 18.0715 3.93687 18.2305C5.97503 19.3152 8.0132 20.4056 10.0514 21.4961C11.4752 22.2599 12.9012 23.0216 14.328 23.7837C15.2582 24.2806 16.1887 24.7776 17.1193 25.2756C18.0898 25.7951 19.0618 26.3146 20.0338 26.8341C21.0058 27.3537 21.9778 27.8732 22.9483 28.3927C23.6677 28.7753 24.387 29.1578 25.1007 29.5403C25.669 29.2124 26.2559 28.9101 26.8421 28.6081C27.1746 28.4369 27.5069 28.2658 27.8354 28.0902C29.8732 27.0056 31.9111 25.9153 33.9489 24.825L33.9499 24.8245C35.3737 24.0608 36.7996 23.2991 38.2264 22.537C39.1566 22.0401 40.0872 21.543 41.0178 21.0451C41.9883 20.5255 42.9603 20.006 43.9323 19.4865C44.9043 18.9669 45.8763 18.4474 46.8468 17.9279C47.2551 17.7109 47.6634 17.4925 48.0716 17.2741C48.4798 17.0557 48.8879 16.8374 49.296 16.6205C49.6728 16.415 50.1581 16.6662 50.1581 17.1115C50.1581 17.12 50.1595 17.1272 50.161 17.1343Z"
          fill="#00C9BD"
        />
      </svg>
    </>
  );
};
export const Tickbtn = () => {
  return (
    <>
      <svg
        width="1.6rem"
        height="1.6rem"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="1.6rem" height="1.6rem" rx="2" fill="#B9BBCC" />
        <path
          d="M12 5.44531L6.88 10.5653L4 7.68531"
          stroke="white"
          strokeWidth="0.96"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Falsebtn = () => {
  return (
    <>
      <svg
        width="1.6rem"
        height="1.6rem"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="1.6rem" height="1.6rem" rx="2" fill="#B3261E" />
        <path
          d="M11.2746 12L8.00257 8.72494L4.73055 12L4 11.2699L7.27717 8L4 4.73008L4.73055 4L8.00257 7.27506L11.2746 4.00514L12 4.73008L8.72797 8L12 11.2699L11.2746 12Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const AppButton = () => {
  return (
    <>
      <svg
        width="2.4rem"
        height="2.4rem"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 3H3V10H10V3Z"
          stroke="url(#paint0_linear_585_11329)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 3H3V10H10V3Z"
          stroke="url(#paint1_linear_585_11329)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 3H14V10H21V3Z"
          stroke="url(#paint2_linear_585_11329)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 3H14V10H21V3Z"
          stroke="url(#paint3_linear_585_11329)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 14H14V21H21V14Z"
          stroke="url(#paint4_linear_585_11329)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 14H14V21H21V14Z"
          stroke="url(#paint5_linear_585_11329)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 14H3V21H10V14Z"
          stroke="url(#paint6_linear_585_11329)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 14H3V21H10V14Z"
          stroke="url(#paint7_linear_585_11329)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_585_11329"
            x1="11.9928"
            y1="1.97334"
            x2="11.9928"
            y2="21.2137"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#16A085" />
            <stop offset="1" stop-color="#1970A9" stop-opacity="0.56" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_585_11329"
            x1="12.2838"
            y1="-3.87718"
            x2="12.2838"
            y2="20.9398"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1970A9" />
            <stop offset="1" stop-color="#3498DB" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_585_11329"
            x1="11.9928"
            y1="1.97334"
            x2="11.9928"
            y2="21.2137"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#16A085" />
            <stop offset="1" stop-color="#1970A9" stop-opacity="0.56" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_585_11329"
            x1="12.2838"
            y1="-3.87718"
            x2="12.2838"
            y2="20.9398"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1970A9" />
            <stop offset="1" stop-color="#3498DB" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_585_11329"
            x1="11.9928"
            y1="1.97334"
            x2="11.9928"
            y2="21.2137"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#16A085" />
            <stop offset="1" stop-color="#1970A9" stop-opacity="0.56" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_585_11329"
            x1="12.2838"
            y1="-3.87718"
            x2="12.2838"
            y2="20.9398"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1970A9" />
            <stop offset="1" stop-color="#3498DB" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_585_11329"
            x1="11.9928"
            y1="1.97334"
            x2="11.9928"
            y2="21.2137"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#16A085" />
            <stop offset="1" stop-color="#1970A9" stop-opacity="0.56" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_585_11329"
            x1="12.2838"
            y1="-3.87718"
            x2="12.2838"
            y2="20.9398"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1970A9" />
            <stop offset="1" stop-color="#3498DB" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export const DarkTheme = () => {
  return (
    <>
      <svg
        width="1.8rem"
        height="1.8rem"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.00002 9.0002C10.4217 7.54053 10.773 5.34509 9.87789 3.51466C9.82188 3.38141 9.84742 3.22783 9.94353 3.11986C10.0396 3.0119 10.1892 2.96875 10.3281 3.00895C11.3972 3.28454 12.3732 3.84128 13.1545 4.62138C15.5729 6.97734 15.6239 10.8475 13.2686 13.2665C10.8498 15.622 6.97962 15.5713 4.62345 13.1532C3.8429 12.3723 3.28586 11.3966 3.01028 10.3275C2.96987 10.1885 3.01308 10.0386 3.12129 9.94241C3.2295 9.84622 3.38341 9.82089 3.51674 9.87731C5.34636 10.772 7.54079 10.421 9.00002 9.0002Z"
          stroke="#323232"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const LanguageButton = () => {
  return (
    <>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z"
          fill="url(#paint0_linear_598_11346)"
        />
        <path
          d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z"
          fill="url(#paint1_linear_598_11346)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_598_11346"
            x1="11.992"
            y1="0.859269"
            x2="11.992"
            y2="22.2374"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#16A085" />
            <stop offset="1" stop-color="#1970A9" stop-opacity="0.56" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_598_11346"
            x1="12.3153"
            y1="-5.64131"
            x2="12.3153"
            y2="21.9331"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1970A9" />
            <stop offset="1" stop-color="#3498DB" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export const NotificationIcon = () => {
  return (
    <>
      <svg
        style={{ width: "2.4rem", height: "2.4rem" }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.99398 13V9C5.99398 5.686 8.68298 3 12 3C15.317 3 18.006 5.686 18.006 9V13C18.006 13.986 18.454 14.919 19.223 15.537L19.532 15.785C20.449 16.521 19.928 18 18.752 18H5.24798C4.07198 18 3.55098 16.521 4.46798 15.785L4.77698 15.537C5.54698 14.919 5.99398 13.986 5.99398 13Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 21H13.5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const CarrierDisableIcon = () => {
  return (
    <>
      <svg
        width="1.3rem"
        height="1.3rem"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 6.5C13 6.59813 12.9672 6.67998 12.9016 6.74556C12.8361 6.81113 12.7542 6.84392 12.6561 6.84392H11.9951C11.9515 7.23002 11.8866 7.5909 11.8004 7.92656C11.7142 8.26222 11.5916 8.58826 11.4324 8.90466C11.3902 8.98857 11.3238 9.04589 11.233 9.07662C11.1422 9.1078 11.0562 9.1039 10.975 9.06492C10.8939 9.02595 10.84 8.96175 10.8134 8.87233C10.7868 8.78291 10.7902 8.6951 10.8237 8.60889C10.9686 8.29203 11.0867 7.94697 11.1779 7.57371C11.2692 7.19999 11.3148 6.84208 11.3148 6.5C11.3148 5.1702 10.8448 4.03528 9.90476 3.09524C8.96473 2.15521 7.82981 1.68519 6.5 1.68519C6.14875 1.68519 5.79314 1.73082 5.43318 1.82207C5.07321 1.91332 4.7348 2.0314 4.41794 2.1763C4.33127 2.20977 4.24117 2.21551 4.14762 2.1935C4.05408 2.17149 3.98323 2.1199 3.93508 2.03873C3.88693 1.95757 3.87639 1.87159 3.90344 1.7808C3.9305 1.69 3.98552 1.62328 4.06852 1.58064C4.39409 1.41327 4.72471 1.28625 5.06037 1.19958C5.39603 1.11291 5.76127 1.04826 6.15609 1.00561V0.34392C6.15609 0.246248 6.18887 0.164396 6.25445 0.0983646C6.32002 0.0323329 6.40187 -0.00045381 6.5 4.74365e-06C6.59813 0.000463297 6.67998 0.03325 6.74556 0.0983646C6.81113 0.163479 6.84392 0.245331 6.84392 0.34392V1.00561C8.2769 1.13951 9.45997 1.67327 10.3931 2.60688C11.3263 3.5405 11.8603 4.72357 11.9951 6.15609H12.6561C12.7542 6.15609 12.8361 6.18887 12.9016 6.25445C12.9672 6.32002 13 6.40187 13 6.5ZM6.15609 12.6561V11.9951C4.72311 11.8607 3.54004 11.3267 2.60688 10.3931C1.67373 9.45951 1.13997 8.27644 1.00561 6.84392H0.34392C0.246248 6.84392 0.164396 6.81113 0.0983646 6.74556C0.0323329 6.67998 -0.00045381 6.59813 4.74365e-06 6.5C0.000463297 6.40187 0.03325 6.32002 0.0983646 6.25445C0.163479 6.18887 0.245331 6.15609 0.34392 6.15609H1.00561C1.06293 5.56914 1.18949 5.01658 1.3853 4.49842C1.58064 3.98025 1.83399 3.52032 2.14535 3.11863L0.510375 1.48503C0.446178 1.42083 0.411786 1.34173 0.4072 1.24773C0.402615 1.15373 0.437006 1.0705 0.510375 0.998047C0.583744 0.925595 0.664908 0.888911 0.753867 0.887994C0.842826 0.887077 0.92399 0.923761 0.997359 0.998047L11.9855 11.9861C12.0616 12.0623 12.0996 12.1462 12.0996 12.2379C12.0996 12.3301 12.0616 12.4142 11.9855 12.4903C11.9098 12.5545 11.8259 12.5896 11.7337 12.5956C11.6415 12.6015 11.5574 12.5664 11.4813 12.4903L9.88138 10.8553C9.48014 11.1667 9.02044 11.4203 8.50228 11.6161C7.98411 11.8119 7.43132 11.9384 6.84392 11.9958V12.6561C6.84392 12.7542 6.81113 12.8361 6.74556 12.9016C6.67998 12.9672 6.59813 13 6.5 13C6.40187 13 6.32002 12.9672 6.25445 12.9016C6.18887 12.8361 6.15609 12.7542 6.15609 12.6561ZM6.5 11.3148C7.01817 11.3148 7.54298 11.2199 8.07445 11.0301C8.60499 10.8398 9.04222 10.6164 9.38614 10.3601L2.6399 3.61387C2.38311 3.95778 2.16002 4.38859 1.97064 4.9063C1.78034 5.42309 1.68519 5.95432 1.68519 6.5C1.68519 7.82981 2.15521 8.96473 3.09524 9.90476C4.03528 10.8448 5.1702 11.3148 6.5 11.3148Z"
          fill="#A20100"
        />
      </svg>
    </>
  );
};

export const Tag = ({ text }) => {
  return (
    <>
      <svg
        width="180"
        height="4.2rem"
        viewBox="0 0 180 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.957031 8.35469C0.957031 4.07383 4.42735 0.603516 8.70821 0.603516H149.231C151.912 0.603516 154.402 1.98837 155.816 4.26543L171.767 29.9506C174.988 35.1372 171.227 41.8386 165.121 41.7908L8.64748 40.5648C4.39046 40.5314 0.957031 37.071 0.957031 32.8138V8.35469Z"
          fill="#6B88EF"
        />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          fill="white"
          fontSize="1.6rem"
          fontWeight="600"
          dy=".3em"
        >
          {text}
        </text>
      </svg>
    </>
  );
};
export const ProfilesettingIcon = () => {
  return (
    <>
      <svg
        width="1.8rem"
        height="1.8rem"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 15V14.4375C15 12.6771 13.5729 11.25 11.8125 11.25H6.1875C4.42709 11.25 3 12.6771 3 14.4375V15"
          stroke="#323232"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="9"
          cy="5.25"
          r="3"
          stroke="#323232"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Home = () => {
  return (
    <svg
      style={{ width: "2rem", height: "2rem" }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 18V12.5C12.5 11.9477 12.0523 11.5 11.5 11.5H8.5C7.94772 11.5 7.5 11.9477 7.5 12.5V18C7.5 18.5523 7.05228 19 6.5 19H2.5C1.67157 19 1 18.3284 1 17.5V8.47484C0.999998 7.85955 1.2832 7.27851 1.76786 6.89945L8.76786 1.42463C9.49174 0.858457 10.5083 0.858457 11.2322 1.42463L18.2322 6.89943C18.7168 7.27849 19 7.85954 19 8.47482V17.5C19 18.3284 18.3284 19 17.5 19H13.5C12.9477 19 12.5 18.5523 12.5 18Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LogoutIcon = () => {
  return (
    <>
      <svg
        width="1.8rem"
        height="1.8rem"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.25 9H11.625"
          stroke="#323232"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 6.00016V4.75053C5.99998 4.01726 6.53011 3.39146 7.2534 3.27091L13.2534 2.27091C13.6883 2.19842 14.1331 2.32097 14.4696 2.60598C14.806 2.89099 15 3.30959 15 3.75052V14.2498C15 14.6907 14.806 15.1093 14.4696 15.3943C14.1331 15.6793 13.6883 15.8019 13.2534 15.7294L7.2534 14.7294C6.53012 14.6088 6 13.983 6 13.2498V12.0002"
          stroke="#323232"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.375 6.75L11.625 9L9.375 11.25"
          stroke="#323232"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const PrepaidIcon = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" fillOpacity="0.15" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.6395 36.1665H43.1957C44.3763 36.1665 45.3333 37.1932 45.3333 38.4582V44.8748C45.3333 46.1398 44.3763 47.1665 43.1938 47.1665H34.6377C33.457 47.1665 32.5 46.1398 32.5 44.8748V38.4582C32.5 37.1932 33.457 36.1665 34.6395 36.1665Z"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.6665 32.445V50.8333C52.6665 52.8592 51.0257 54.5 48.9998 54.5H28.8332C26.8073 54.5 25.1665 52.8592 25.1665 50.8333V25.1667C25.1665 23.1408 26.8073 21.5 28.8332 21.5H41.947C42.9388 21.5 43.8903 21.9015 44.5797 22.6147L51.6325 29.893C52.2962 30.5768 52.6665 31.4935 52.6665 32.445Z"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const PrepaidIconActive = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.6395 36.1665H43.1957C44.3763 36.1665 45.3333 37.1932 45.3333 38.4582V44.8748C45.3333 46.1398 44.3763 47.1665 43.1938 47.1665H34.6377C33.457 47.1665 32.5 46.1398 32.5 44.8748V38.4582C32.5 37.1932 33.457 36.1665 34.6395 36.1665Z"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.6665 32.445V50.8333C52.6665 52.8592 51.0257 54.5 48.9998 54.5H28.8332C26.8073 54.5 25.1665 52.8592 25.1665 50.8333V25.1667C25.1665 23.1408 26.8073 21.5 28.8332 21.5H41.947C42.9388 21.5 43.8903 21.9015 44.5797 22.6147L51.6325 29.893C52.2962 30.5768 52.6665 31.4935 52.6665 32.445Z"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const PostpaidIcon = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" fillOpacity="0.15" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.171 49.0053V38.0007C47.1713 37.0278 46.7849 36.0946 46.0969 35.4066C45.4089 34.7186 44.4758 34.3323 43.5028 34.3325H25.1618C24.1889 34.3323 23.2557 34.7186 22.5677 35.4066C21.8798 36.0946 21.4934 37.0278 21.4937 38.0007V49.0053C21.4934 49.9782 21.8798 50.9114 22.5677 51.5994C23.2557 52.2874 24.1889 52.6738 25.1618 52.6735H43.5028C45.5287 52.6735 47.171 51.0311 47.171 49.0053Z"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.4937 41.813H47.171"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.3623 34.3326L29.5816 26.0425C29.8334 25.103 30.4487 24.3023 31.2917 23.8171C32.1348 23.3319 33.1362 23.2021 34.0751 23.4564L51.7925 28.2068C52.732 28.4586 53.5327 29.0739 54.0179 29.9169C54.5031 30.76 54.6329 31.7614 54.3786 32.7003L51.5357 43.3197C51.0298 45.2309 49.0955 46.3931 47.1706 45.9425"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const PostpaidIconActive = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.171 49.0053V38.0007C47.1713 37.0278 46.7849 36.0946 46.0969 35.4066C45.4089 34.7186 44.4758 34.3323 43.5028 34.3325H25.1618C24.1889 34.3323 23.2557 34.7186 22.5677 35.4066C21.8798 36.0946 21.4934 37.0278 21.4937 38.0007V49.0053C21.4934 49.9782 21.8798 50.9114 22.5677 51.5994C23.2557 52.2874 24.1889 52.6738 25.1618 52.6735H43.5028C45.5287 52.6735 47.171 51.0311 47.171 49.0053Z"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.4937 41.813H47.171"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.3623 34.3326L29.5816 26.0425C29.8334 25.103 30.4487 24.3023 31.2917 23.8171C32.1348 23.3319 33.1362 23.2021 34.0751 23.4564L51.7925 28.2068C52.732 28.4586 53.5327 29.0739 54.0179 29.9169C54.5031 30.76 54.6329 31.7614 54.3786 32.7003L51.5357 43.3197C51.0298 45.2309 49.0955 46.3931 47.1706 45.9425"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const InventoryIcon = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" fillOpacity="0.15" />
        <path
          d="M54.5 34.1512V31.951C54.5 29.9198 53.3806 28.0541 51.5885 27.0981L40.5885 21.2307C38.9707 20.3678 37.0293 20.3678 35.4115 21.2307L24.4115 27.0981C22.6194 28.0541 21.5 29.9198 21.5 31.951V50.8335C21.5 52.8586 23.1416 54.5002 25.1667 54.5002H36.1667"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.0035 39.8335H30.6668C29.6543 39.8335 28.8335 40.6543 28.8335 41.6668V54.5002"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.1665 54.4998H43.4998C42.4873 54.4998 41.6665 53.679 41.6665 52.6665V48.9998C41.6665 47.9873 42.4873 47.1665 43.4998 47.1665H47.1665C48.179 47.1665 48.9998 47.9873 48.9998 48.9998V52.6665C48.9998 53.679 48.179 54.4998 47.1665 54.4998Z"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.5 54.4998H50.8333C49.8208 54.4998 49 53.679 49 52.6665V48.9998C49 47.9873 49.8208 47.1665 50.8333 47.1665H54.5C55.5125 47.1665 56.3333 47.9873 56.3333 48.9998V52.6665C56.3333 53.679 55.5125 54.4998 54.5 54.4998Z"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.8335 47.1668H47.1668C46.1543 47.1668 45.3335 46.346 45.3335 45.3335V41.6668C45.3335 40.6543 46.1543 39.8335 47.1668 39.8335H50.8335C51.846 39.8335 52.6668 40.6543 52.6668 41.6668V45.3335C52.6668 46.346 51.846 47.1668 50.8335 47.1668Z"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.1668 47.1667H28.8335"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.3335 32.5002H41.6668"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const InventoryIconActive = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" />
        <path
          d="M54.5 34.1512V31.951C54.5 29.9198 53.3806 28.0541 51.5885 27.0981L40.5885 21.2307C38.9707 20.3678 37.0293 20.3678 35.4115 21.2307L24.4115 27.0981C22.6194 28.0541 21.5 29.9198 21.5 31.951V50.8335C21.5 52.8586 23.1416 54.5002 25.1667 54.5002H36.1667"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.0035 39.8335H30.6668C29.6543 39.8335 28.8335 40.6543 28.8335 41.6668V54.5002"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.1665 54.4998H43.4998C42.4873 54.4998 41.6665 53.679 41.6665 52.6665V48.9998C41.6665 47.9873 42.4873 47.1665 43.4998 47.1665H47.1665C48.179 47.1665 48.9998 47.9873 48.9998 48.9998V52.6665C48.9998 53.679 48.179 54.4998 47.1665 54.4998Z"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.5 54.4998H50.8333C49.8208 54.4998 49 53.679 49 52.6665V48.9998C49 47.9873 49.8208 47.1665 50.8333 47.1665H54.5C55.5125 47.1665 56.3333 47.9873 56.3333 48.9998V52.6665C56.3333 53.679 55.5125 54.4998 54.5 54.4998Z"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.8335 47.1668H47.1668C46.1543 47.1668 45.3335 46.346 45.3335 45.3335V41.6668C45.3335 40.6543 46.1543 39.8335 47.1668 39.8335H50.8335C51.846 39.8335 52.6668 40.6543 52.6668 41.6668V45.3335C52.6668 46.346 51.846 47.1668 50.8335 47.1668Z"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.1668 47.1667H28.8335"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.3335 32.5002H41.6668"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const SearchIco = () => {
  return (
    <svg
      style={{ width: "2.4rem", height: "2.4rem" }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9999 20.0007L16.3762 16.377"
        stroke="#989898"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 11.25C4 15.2541 7.24594 18.5 11.25 18.5C15.2541 18.5 18.5 15.2541 18.5 11.25C18.5 7.24594 15.2541 4 11.25 4V4C7.24606 4.00029 4.00029 7.24606 4 11.25"
        stroke="#989898"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BulkIcon = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" fillOpacity="0.15" />
        <path
          d="M43.4998 37.6333H52.2998C54.5274 37.6333 56.3332 35.8275 56.3332 33.6V25.5333C56.3332 23.3058 54.5274 21.5 52.2998 21.5H40.1998C37.9723 21.5 36.1665 23.3058 36.1665 25.5333V32.5"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.7124 27.5498L45.2328 29.3283C45.8737 29.6458 46.6262 29.6458 47.2672 29.3283L50.7874 27.5498"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.6665 42.4005V50.4672C19.6665 52.6947 21.4723 54.5005 23.6998 54.5005H35.7998C38.0274 54.5005 39.8332 52.6947 39.8332 50.4672V42.4005C39.8332 41.3308 39.4082 40.3049 38.6518 39.5485C37.8954 38.7921 36.8695 38.3672 35.7998 38.3672H23.6998C21.4723 38.3672 19.6665 40.173 19.6665 42.4005Z"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.2124 44.4165L28.7328 46.195C29.3737 46.5125 30.1262 46.5125 30.7672 46.195L34.2874 44.4165"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5835 27.9167H29.7502"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2502 24.25L20.5835 27.9167L24.2502 31.5833"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.4167 48.0832H46.25"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.75 51.7498L55.4167 48.0832L51.75 44.4165"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const BulkIconActive = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" />
        <path
          d="M43.4998 37.6333H52.2998C54.5274 37.6333 56.3332 35.8275 56.3332 33.6V25.5333C56.3332 23.3058 54.5274 21.5 52.2998 21.5H40.1998C37.9723 21.5 36.1665 23.3058 36.1665 25.5333V32.5"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.7124 27.5498L45.2328 29.3283C45.8737 29.6458 46.6262 29.6458 47.2672 29.3283L50.7874 27.5498"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.6665 42.4005V50.4672C19.6665 52.6947 21.4723 54.5005 23.6998 54.5005H35.7998C38.0274 54.5005 39.8332 52.6947 39.8332 50.4672V42.4005C39.8332 41.3308 39.4082 40.3049 38.6518 39.5485C37.8954 38.7921 36.8695 38.3672 35.7998 38.3672H23.6998C21.4723 38.3672 19.6665 40.173 19.6665 42.4005Z"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.2124 44.4165L28.7328 46.195C29.3737 46.5125 30.1262 46.5125 30.7672 46.195L34.2874 44.4165"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5835 27.9167H29.7502"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2502 24.25L20.5835 27.9167L24.2502 31.5833"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.4167 48.0832H46.25"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.75 51.7498L55.4167 48.0832L51.75 44.4165"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const BatchIcon = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" fillOpacity="0.15" />
        <path
          d="M52.6668 31.5833H46.2502C44.2251 31.5833 42.5835 29.9417 42.5835 27.9167V21.5"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.0002 43.5V52.6667"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.3335 49L38.0002 52.6667L41.6668 49"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.3335 54.5H47.1668C50.2044 54.5 52.6668 52.0376 52.6668 49V31.1115C52.6668 29.6528 52.0874 28.2539 51.0559 27.2224L46.9444 23.1109C45.913 22.0795 44.514 21.5 43.0553 21.5H28.8335C25.7959 21.5 23.3335 23.9624 23.3335 27V49C23.3335 52.0376 25.7959 54.5 28.8335 54.5H30.6668"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const BatchIconActive = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" />
        <path
          d="M52.6668 31.5833H46.2502C44.2251 31.5833 42.5835 29.9417 42.5835 27.9167V21.5"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.0002 43.5V52.6667"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.3335 49L38.0002 52.6667L41.6668 49"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.3335 54.5H47.1668C50.2044 54.5 52.6668 52.0376 52.6668 49V31.1115C52.6668 29.6528 52.0874 28.2539 51.0559 27.2224L46.9444 23.1109C45.913 22.0795 44.514 21.5 43.0553 21.5H28.8335C25.7959 21.5 23.3335 23.9624 23.3335 27V49C23.3335 52.0376 25.7959 54.5 28.8335 54.5H30.6668"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const SettingsIcon = (props) => {
  return (
    <>
      <svg
        width={85}
        height={70}
        viewBox="0 0 85 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g filter="url(#filter0_b_1253_34020)">
          <mask
            id="mask0_1253_34020"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={16}
            y={1}
            width={69}
            height={69}
          >
            <path
              d="M69.7208 21.526C71.6903 24.3498 73.0238 27.5672 73.6292 30.9564H81.0242V39.3853H73.6292C73.0238 42.7744 71.6903 45.9919 69.7208 48.8156L74.9521 54.047L68.9913 60.0078L63.76 54.7764C60.9362 56.746 57.7187 58.0795 54.3296 58.6849V66.0799H45.9007V58.6849C42.5115 58.0795 39.2941 56.746 36.4703 54.7764L31.239 60.0078L25.2781 54.047L30.5095 48.8156C28.54 45.9919 27.2065 42.7744 26.6011 39.3853H19.2061V30.9564H26.6011C27.2065 27.5672 28.54 24.3498 30.5095 21.526L25.2781 16.2946L31.239 10.3338L36.4703 15.5652C39.2941 13.5956 42.5115 12.2621 45.9007 11.6567V4.26172H54.3296V11.6567C57.7187 12.2621 60.9362 13.5956 63.76 15.5652L68.9913 10.3338L74.9521 16.2946L69.7208 21.526Z"
              fill="white"
              stroke="white"
              strokeWidth={6.18182}
              strokeLinejoin="round"
            />
            <path
              d="M50.115 42.8979C52.1644 42.8979 54.1298 42.0838 55.579 40.6346C57.0281 39.1855 57.8422 37.22 57.8422 35.1706C57.8422 33.1212 57.0281 31.1558 55.579 29.7066C54.1298 28.2575 52.1644 27.4434 50.115 27.4434C48.0656 27.4434 46.1001 28.2575 44.651 29.7066C43.2018 31.1558 42.3877 33.1212 42.3877 35.1706C42.3877 37.22 43.2018 39.1855 44.651 40.6346C46.1001 42.0838 48.0656 42.8979 50.115 42.8979Z"
              fill="black"
              stroke="black"
              strokeWidth={6.18182}
              strokeLinejoin="round"
            />
          </mask>
          <g mask="url(#mask0_1253_34020)">
            <path
              d="M13.0244 -1.91992H87.2062V72.2619H13.0244V-1.91992Z"
              fill="#6286F4"
            />
          </g>
        </g>
        <g filter="url(#filter1_b_1253_34020)">
          <mask
            id="mask1_1253_34020"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={69}
            height={69}
          >
            <path
              d="M53.7208 21.3443C55.6903 24.1681 57.0238 27.3856 57.6292 30.7747H65.0242V39.2036H57.6292C57.0238 42.5928 55.6903 45.8102 53.7208 48.634L58.9521 53.8653L52.9913 59.8262L47.76 54.5948C44.9362 56.5644 41.7187 57.8979 38.3296 58.5033V65.8983H29.9007V58.5033C26.5115 57.8979 23.2941 56.5644 20.4703 54.5948L15.239 59.8262L9.27815 53.8653L14.5095 48.634C12.54 45.8102 11.2065 42.5928 10.6011 39.2036H3.20605V30.7747H10.6011C11.2065 27.3856 12.54 24.1681 14.5095 21.3443L9.27815 16.113L15.239 10.1522L20.4703 15.3835C23.2941 13.414 26.5115 12.0805 29.9007 11.4751V4.08008H38.3296V11.4751C41.7187 12.0805 44.9362 13.414 47.76 15.3835L52.9913 10.1522L58.9521 16.113L53.7208 21.3443Z"
              fill="#6286F4"
              stroke="#6286F4"
              strokeWidth={6.18182}
              strokeLinejoin="round"
            />
            <path
              d="M34.115 42.7163C36.1644 42.7163 38.1298 41.9021 39.579 40.453C41.0281 39.0039 41.8422 37.0384 41.8422 34.989C41.8422 32.9396 41.0281 30.9741 39.579 29.525C38.1298 28.0758 36.1644 27.2617 34.115 27.2617C32.0656 27.2617 30.1001 28.0758 28.651 29.525C27.2018 30.9741 26.3877 32.9396 26.3877 34.989C26.3877 37.0384 27.2018 39.0039 28.651 40.453C30.1001 41.9021 32.0656 42.7163 34.115 42.7163Z"
              fill="black"
              stroke="black"
              strokeWidth={6.18182}
              strokeLinejoin="round"
            />
          </mask>
          <g mask="url(#mask1_1253_34020)">
            <path
              d="M-2.97559 -2.10156H71.2062V72.0803H-2.97559V-2.10156Z"
              fill="url(#paint0_linear_1253_34020)"
              fillOpacity={0.5}
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_b_1253_34020"
            x={4.67887}
            y={-10.2655}
            width={90.8727}
            height={90.8727}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation={5.71818} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_1253_34020"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_1253_34020"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_b_1253_34020"
            x={-35.8848}
            y={-35.0107}
            width={140}
            height={140}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation={18} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_1253_34020"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_1253_34020"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_1253_34020"
            x1={34.1153}
            y1={-2.10156}
            x2={34.1153}
            y2={72.0803}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6286F4" stopOpacity={0.4} />
            <stop offset={0.698} stopColor="#6286F4" stopOpacity={0.1} />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export const ReportsIcon = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" fillOpacity="0.15" />
        <path
          d="M32.4996 22.459C26.7035 24.4984 22.5222 29.5917 21.6509 35.674C20.7795 41.7564 23.3627 47.8187 28.3531 51.4034C33.3435 54.9881 39.9132 55.5004 45.399 52.7327"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38 21.5V37.9998L49.6673 49.6671C54.3862 44.9481 55.7978 37.8512 53.2439 31.6857C50.69 25.5201 44.6736 21.5 38 21.5H38Z"
          stroke="#2725A8"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const ReportsIconActive = () => {
  return (
    <>
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="76" height="76" rx="8" fill="#475CED" />
        <path
          d="M32.4996 22.459C26.7035 24.4984 22.5222 29.5917 21.6509 35.674C20.7795 41.7564 23.3627 47.8187 28.3531 51.4034C33.3435 54.9881 39.9132 55.5004 45.399 52.7327"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38 21.5V37.9998L49.6673 49.6671C54.3862 44.9481 55.7978 37.8512 53.2439 31.6857C50.69 25.5201 44.6736 21.5 38 21.5H38Z"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Prepaidnotification = () => {
  return (
    <>
      <svg
        width="2.4rem"
        height="2.4rem"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 9H1"
          stroke="#2725A8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 15H3"
          stroke="#2725A8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 11.9999L2 12.0001"
          stroke="#2725A8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 18.148C4.32415 19.8872 6.07539 20.9971 8 21H16C17.3261 21 18.5979 20.4732 19.5356 19.5356C20.4732 18.5979 21 17.3261 21 16V8C21 6.67391 20.4732 5.40213 19.5356 4.46445C18.5979 3.52676 17.3261 2.99998 16 3H8C6.07538 3.00289 4.32414 4.11281 3.5 5.85205"
          stroke="#2725A8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 7.5V8.5"
          stroke="#2725A8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 16.5V15.5"
          stroke="#2725A8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.8587 14.25C10.254 15.0614 11.0991 15.5548 12 15.5C13.0995 15.6201 14.0957 14.8453 14.25 13.75V13.75C14.25 12.9942 13.7165 12.3433 12.9753 12.1951L11.0247 11.805C10.2835 11.6568 9.75 11.0059 9.75 10.25V10.25C9.90432 9.1548 10.9005 8.38002 12 8.50005C12.9009 8.44533 13.746 8.93868 14.1413 9.75005"
          stroke="#2725A8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const SinptelNotification = () => {
  return (
    <>
      <svg
        width="2.2rem"
        height="1.6rem"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.79229 0.263731C10.0828 0.0300066 10.8029 2.00791 9.30235 2.5454C7.44867 2.98621 5.63885 3.28807 3.32012 5.19517C3.78402 5.66833 4.24792 6.14149 4.7122 6.61465C8.34647 3.9036 12.6985 3.84383 16.432 6.05737C15.8439 6.64967 15.2561 7.24198 14.6684 7.83429C12.1458 6.53662 8.91 6.33334 5.89157 8.83313C5.17956 9.63176 4.47487 9.77146 3.74517 9.1487C2.66851 8.08666 1.59184 7.02462 0.51518 5.96258C0.11898 5.40872 0.128597 4.85486 0.61096 4.30139C2.90353 2.09508 5.62154 0.731181 8.79267 0.263731H8.79229Z"
          fill="#475CED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7166 2.57625C11.4738 2.09928 11.6484 0.620803 12.8124 0.22073C14.6938 0.0989195 19.1535 1.87964 21.4511 4.43729C21.8634 4.87772 21.8781 5.4586 21.4511 5.95156C18.2669 9.12016 15.083 12.2888 11.8988 15.457C10.6179 16.4406 9.15466 15.0097 9.99668 13.8586C12.9009 10.974 15.8054 8.08934 18.7096 5.2047C16.9359 3.80007 14.9719 2.845 12.7166 2.57587V2.57625Z"
          fill="#475CED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1282 9.33251C12.4516 10.0021 11.7753 10.6713 11.0987 11.3409C10.1682 11.2529 9.32506 11.5971 8.56459 12.3504C7.28521 13.3702 6.02584 11.6127 6.84862 10.6892C8.71922 8.93015 10.8183 8.51219 13.1282 9.33289V9.33251Z"
          fill="#475CED"
        />
      </svg>
    </>
  );
};
export const Calendar = () => {
  return (
    <>
      <svg
        width="2.4rem"
        height="2.4rem"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 2V6"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 2V6"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 9H21"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.01463 12.729C6.87663 12.729 6.76463 12.841 6.76563 12.979C6.76563 13.117 6.87763 13.229 7.01563 13.229C7.15363 13.229 7.26563 13.117 7.26563 12.979C7.26563 12.841 7.15363 12.729 7.01463 12.729"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0146 12.729C11.8766 12.729 11.7646 12.841 11.7656 12.979C11.7656 13.117 11.8776 13.229 12.0156 13.229C12.1536 13.229 12.2656 13.117 12.2656 12.979C12.2656 12.841 12.1536 12.729 12.0146 12.729"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.0146 12.729C16.8766 12.729 16.7646 12.841 16.7656 12.979C16.7656 13.117 16.8776 13.229 17.0156 13.229C17.1536 13.229 17.2656 13.117 17.2656 12.979C17.2656 12.841 17.1536 12.729 17.0146 12.729"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.01463 16.729C6.87663 16.729 6.76463 16.841 6.76563 16.979C6.76563 17.117 6.87763 17.229 7.01563 17.229C7.15363 17.229 7.26563 17.117 7.26563 16.979C7.26563 16.841 7.15363 16.729 7.01463 16.729"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0146 16.729C11.8766 16.729 11.7646 16.841 11.7656 16.979C11.7656 17.117 11.8776 17.229 12.0156 17.229C12.1536 17.229 12.2656 17.117 12.2656 16.979C12.2656 16.841 12.1536 16.729 12.0146 16.729"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Search = () => {
  return (
    <>
      <svg
        width="2.4rem"
        height="2.4rem"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9987 19.9999L16.375 16.3762"
          stroke="#B9BBCC"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 11.25C4 15.2541 7.24594 18.5 11.25 18.5C15.2541 18.5 18.5 15.2541 18.5 11.25C18.5 7.24594 15.2541 4 11.25 4V4C7.24606 4.00029 4.00029 7.24606 4 11.25"
          stroke="#B9BBCC"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const SelectorIcon = () => {
  return (
    <>
      <svg
        width="2.4rem"
        height="2.4rem"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 21H5C3.895 21 3 20.105 3 19V15C3 13.895 3.895 13 5 13H9C10.105 13 11 13.895 11 15V19C11 20.105 10.105 21 9 21Z"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 17H14C15.105 17 16 16.105 16 15V10C16 8.895 15.105 8 14 8H9C7.895 8 7 8.895 7 10V13"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 14H19C20.105 14 21 13.105 21 12V5C21 3.895 20.105 3 19 3H12C10.895 3 10 3.895 10 5V8"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Status = () => {
  return (
    <>
      <svg
        width="2.4rem"
        height="2.4rem"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.8 13.6V18C8.8 19.1046 9.69543 20 10.8 20H13.2C14.3046 20 15.2 19.1046 15.2 18V13.6L19 10.75C19.6295 10.2779 20 9.53689 20 8.75V6.5C20 5.11929 18.8807 4 17.5 4H6.5C5.11929 4 4 5.11929 4 6.5V8.75C4 9.53689 4.37049 10.2779 5 10.75L8.8 13.6Z"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const DownloadIcon = () => {
  return (
    <>
      <svg
        width="1.6rem"
        height="1.6rem"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3761 7.40698L8.00447 9.77864L5.63281 7.40698"
          stroke="#475CED"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00144 2.66431V9.7786"
          stroke="#475CED"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3391 10.9636C13.3391 12.2735 12.2773 13.3353 10.9674 13.3353H5.03962C3.72979 13.3353 2.66797 12.2735 2.66797 10.9636"
          stroke="#475CED"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Dot = () => {
  return (
    <>
      <svg
        width="0.8rem"
        height="0.8rem"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="4" cy="4" r="4" fill="#B9BBCC" />
      </svg>
    </>
  );
};
export const FalseDialog = ({ size = "4rem" }) => {
  return (
    <div style={{ width: size, height: size }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="3" y="3" width="34" height="34" rx="3.5" stroke="#DDE2FC" />

        <path
          d="M13.75 13.75L26.25 26.25"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M13.75 26.25L26.25 13.75"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
export const PrevIcon = () => {
  return (
    <>
      <svg
        width="1.2rem"
        height="1.2rem"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6693 6.00016H1.33594M1.33594 6.00016L6.0026 10.6668M1.33594 6.00016L6.0026 1.3335"
          stroke="#475CED"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const NextIcon = () => {
  return (
    <>
      <svg
        width="1.6rem"
        height="1.6rem"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.33594 8.00016H12.6693M12.6693 8.00016L8.0026 3.3335M12.6693 8.00016L8.0026 12.6668"
          stroke="#475CED"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Error = () => {
  return (
    <>
      <svg
        width="1.6rem"
        height="1.6rem"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.9987 11.3333C8.18759 11.3333 8.34592 11.2694 8.4737 11.1416C8.60148 11.0138 8.66536 10.8555 8.66536 10.6666C8.66536 10.4777 8.60148 10.3194 8.4737 10.1916C8.34592 10.0638 8.18759 9.99992 7.9987 9.99992C7.80981 9.99992 7.65148 10.0638 7.5237 10.1916C7.39592 10.3194 7.33203 10.4777 7.33203 10.6666C7.33203 10.8555 7.39592 11.0138 7.5237 11.1416C7.65148 11.2694 7.80981 11.3333 7.9987 11.3333ZM7.33203 8.66659H8.66536V4.66659H7.33203V8.66659ZM7.9987 14.6666C7.07648 14.6666 6.20981 14.4916 5.3987 14.1416C4.58759 13.7916 3.88203 13.3166 3.28203 12.7166C2.68203 12.1166 2.20703 11.411 1.85703 10.5999C1.50703 9.78881 1.33203 8.92214 1.33203 7.99992C1.33203 7.0777 1.50703 6.21103 1.85703 5.39992C2.20703 4.58881 2.68203 3.88325 3.28203 3.28325C3.88203 2.68325 4.58759 2.20825 5.3987 1.85825C6.20981 1.50825 7.07648 1.33325 7.9987 1.33325C8.92092 1.33325 9.78759 1.50825 10.5987 1.85825C11.4098 2.20825 12.1154 2.68325 12.7154 3.28325C13.3154 3.88325 13.7904 4.58881 14.1404 5.39992C14.4904 6.21103 14.6654 7.0777 14.6654 7.99992C14.6654 8.92214 14.4904 9.78881 14.1404 10.5999C13.7904 11.411 13.3154 12.1166 12.7154 12.7166C12.1154 13.3166 11.4098 13.7916 10.5987 14.1416C9.78759 14.4916 8.92092 14.6666 7.9987 14.6666Z"
          fill="#B3261E"
        />
      </svg>
    </>
  );
};
export const CancelPopup = () => {
  return (
    <svg
      width="3.2rem"
      height="3.2rem"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd)">
        {/* Outer white rounded box */}
        <rect x="4" y="4" width="24" height="24" rx="4" fill="white" />
        <rect
          x="4.5"
          y="4.5"
          width="23"
          height="23"
          rx="3.5"
          stroke="#DDE2FC"
        />
        {/* Cross in center */}
        <path
          d="M12 12L20 20"
          stroke="#475CED"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 20L20 12"
          stroke="#475CED"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.278 0 0 0 0 0.361 0 0 0 0 0.929 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.278 0 0 0 0 0.361 0 0 0 0 0.929 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow"
            result="effect2_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const EmptyEnrollment = () => {
  return (
    <>
      <svg
        width="14.4rem"
        height="14.4rem"
        viewBox="0 0 144 144"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="144" height="144" rx="8" fill="#EFF2F8" />
        <path
          d="M107.158 62.0942C110.318 65.2543 110.318 70.3779 107.158 73.538C103.998 76.6981 98.874 76.6981 95.7138 73.538C92.5537 70.3779 92.5537 65.2543 95.7138 62.0942C98.874 58.9341 103.998 58.9341 107.158 62.0942"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M80.8018 47.6494C85.6677 52.5154 85.6677 60.4046 80.8018 65.2706C75.9359 70.1365 68.0467 70.1365 63.1807 65.2706C58.3148 60.4046 58.3148 52.5154 63.1807 47.6494C68.0466 42.7835 75.9358 42.7835 80.8018 47.6494"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.2826 62.0942C51.4428 65.2543 51.4428 70.3779 48.2826 73.538C45.1225 76.6981 39.999 76.6981 36.8388 73.538C33.6787 70.3779 33.6787 65.2543 36.8388 62.0942C39.999 58.9341 45.1225 58.9341 48.2826 62.0942"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M115.985 100V95.6162C115.985 90.0922 111.509 85.6162 105.985 85.6162H102.781"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28 100V95.6162C28 90.0922 32.476 85.6162 38 85.6162H41.204"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M93.341 100V93.5962C93.341 85.8642 87.073 79.5962 79.341 79.5962H64.625C56.893 79.5962 50.625 85.8642 50.625 93.5962V100"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const EmptyRole = () => {
  return (
    <>
      <svg
        width="14.4rem"
        height="14.4rem"
        viewBox="0 0 144 144"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="144" height="144" rx="8" fill="#EFF2F8" />
        <path
          d="M107.158 62.0942C110.318 65.2543 110.318 70.3779 107.158 73.538C103.998 76.6981 98.874 76.6981 95.7138 73.538C92.5537 70.3779 92.5537 65.2543 95.7138 62.0942C98.874 58.9341 103.998 58.9341 107.158 62.0942"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M80.8018 47.6494C85.6677 52.5154 85.6677 60.4046 80.8018 65.2706C75.9359 70.1365 68.0467 70.1365 63.1807 65.2706C58.3148 60.4046 58.3148 52.5154 63.1807 47.6494C68.0466 42.7835 75.9358 42.7835 80.8018 47.6494"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.2826 62.0942C51.4428 65.2543 51.4428 70.3779 48.2826 73.538C45.1225 76.6981 39.999 76.6981 36.8388 73.538C33.6787 70.3779 33.6787 65.2543 36.8388 62.0942C39.999 58.9341 45.1225 58.9341 48.2826 62.0942"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M115.985 100V95.6162C115.985 90.0922 111.509 85.6162 105.985 85.6162H102.781"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28 100V95.6162C28 90.0922 32.476 85.6162 38 85.6162H41.204"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M93.341 100V93.5962C93.341 85.8642 87.073 79.5962 79.341 79.5962H64.625C56.893 79.5962 50.625 85.8642 50.625 93.5962V100"
          stroke="#9C9EB6"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const PlanEmpty = () => {
  return (
    <>
      <svg
        width="8.8rem"
        height="8.8rem"
        viewBox="0 0 88 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="88" height="88" rx="8" fill="#EFF2F8" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.1667 59H34.8333C32.9917 59 31.5 57.5083 31.5 55.6667V32.3333C31.5 30.4917 32.9917 29 34.8333 29H53.1667C55.0083 29 56.5 30.4917 56.5 32.3333V55.6667C56.5 57.5083 55.0083 59 53.1667 59Z"
          stroke="#9C9EB6"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.332 36.5H50.6654"
          stroke="#9C9EB6"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.332 41.5H50.6654"
          stroke="#9C9EB6"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.332 49H50.6654"
          stroke="#9C9EB6"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.332 54H50.6654"
          stroke="#9C9EB6"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.8333 35.25V34"
          stroke="#9C9EB6"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.8333 42.75V44"
          stroke="#9C9EB6"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.662 41.8567C37.9854 42.3867 38.5387 42.7533 39.207 42.7533H39.832H40.577C41.547 42.7533 42.332 41.9667 42.332 40.9983C42.332 40.1933 41.7837 39.4917 41.0037 39.295L38.6604 38.7083C37.8804 38.5117 37.332 37.81 37.332 37.005C37.332 36.0367 38.1187 35.25 39.087 35.25H39.832H40.457C41.1237 35.25 41.6754 35.615 41.9987 36.1433"
          stroke="#9C9EB6"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const PlanEditIcon = () => {
  return (
    <>
      <svg
        width="2.4rem"
        height="2.4rem"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.625 12.001C11.625 12.208 11.793 12.376 12 12.374C12.207 12.374 12.375 12.206 12.375 11.999C12.375 11.792 12.207 11.624 12 11.624C11.793 11.625 11.625 11.793 11.625 12.001"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.625 8.00101C11.625 8.20801 11.793 8.37601 12 8.37401C12.207 8.37401 12.375 8.20601 12.375 7.99901C12.375 7.79201 12.207 7.62401 12 7.62401C11.793 7.62501 11.625 7.79301 11.625 8.00101"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.625 16.001C11.625 16.208 11.793 16.376 12 16.374C12.207 16.374 12.375 16.206 12.375 15.999C12.375 15.792 12.207 15.624 12 15.624C11.793 15.625 11.625 15.793 11.625 16.001"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 7V17C21 19.209 19.209 21 17 21H7C4.791 21 3 19.209 3 17V7C3 4.791 4.791 3 7 3H17C19.209 3 21 4.791 21 7Z"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const RolesIcon = () => {
  return (
    <>
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="80" height="80" rx="8" fill="#EFF2F8" />
        <path
          d="M40.9381 22.0456C43.6655 24.773 43.6655 29.195 40.9381 31.9224C38.2106 34.6498 33.7886 34.6498 31.0612 31.9224C28.3338 29.195 28.3338 24.773 31.0612 22.0456C33.7886 19.3181 38.2106 19.3181 40.9381 22.0456"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.726 41.5919C42.128 40.5539 39.08 39.9819 36 39.9819C27.904 39.9819 20 43.9159 20 49.9659V51.9659C20 53.0699 20.896 53.9659 22 53.9659H40.826"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50 60C44.478 60 40 55.524 40 50C40 44.592 44.6 39.994 50.008 40C55.528 40.004 60 44.48 60 50C60 55.522 55.524 60 50 60"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50 45.9999V47.3399"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50 52.6601V54.0001"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.545 48.0001L47.705 48.6601"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M52.3206 51.3399L53.4606 51.9999"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.545 51.9999L47.705 51.3399"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M52.3206 48.6601L53.4606 48.0001"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.8827 48.1135C52.9246 49.1554 52.9246 50.8447 51.8827 51.8866C50.8408 52.9285 49.1515 52.9285 48.1096 51.8866C47.0676 50.8447 47.0676 49.1554 48.1096 48.1135C49.1515 47.0716 50.8408 47.0716 51.8827 48.1135"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const EmptyUser = () => {
  return (
    <>
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="80" height="80" rx="8" fill="#EFF2F8" />
        <path
          d="M57.5788 35.0471C59.1589 36.6272 59.1589 39.1889 57.5788 40.769C55.9988 42.3491 53.437 42.3491 51.8569 40.769C50.2769 39.1889 50.2769 36.6272 51.8569 35.0471C53.437 33.467 55.9988 33.467 57.5788 35.0471"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.4009 27.8247C46.8339 30.2577 46.8339 34.2023 44.4009 36.6353C41.9679 39.0682 38.0233 39.0682 35.5903 36.6353C33.1574 34.2023 33.1574 30.2577 35.5903 27.8247C38.0233 25.3918 41.9679 25.3918 44.4009 27.8247"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.1413 35.0471C29.7214 36.6272 29.7214 39.1889 28.1413 40.769C26.5613 42.3491 23.9995 42.3491 22.4194 40.769C20.8394 39.1889 20.8394 36.6272 22.4194 35.0471C23.9995 33.467 26.5613 33.467 28.1413 35.0471"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M61.9926 54.0001V51.8081C61.9926 49.0461 59.7546 46.8081 56.9926 46.8081H55.3906"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 54.0001V51.8081C18 49.0461 20.238 46.8081 23 46.8081H24.602"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.6705 54.0001V50.7981C50.6705 46.9321 47.5365 43.7981 43.6705 43.7981H36.3125C32.4465 43.7981 29.3125 46.9321 29.3125 50.7981V54.0001"
          stroke="#9C9EB6"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const BillingEmpty = () => {
  return (
    <>
      <svg
        width="4.8rem"
        height="4.8rem"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="4.8rem" height="4.8rem" rx="8" fill="#EFF2F8" />
        <rect
          x="15"
          y="15"
          width="1.8rem"
          height="1.8rem"
          rx="5"
          stroke="#9C9EB6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 24V26.3684"
          stroke="#9C9EB6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 23.9999L26.1053 22.6841"
          stroke="#9C9EB6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.9998 23.9999L21.8945 22.6841"
          stroke="#9C9EB6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 22.2319V25.7679C19 26.4825 19.3812 27.1427 20 27.4999L23 29.232C23.6188 29.5893 24.3812 29.5893 25 29.232L28 27.4999C28.6188 27.1427 29 26.4825 29 25.7679V22.2319C29 21.5174 28.6188 20.8572 28 20.4999L25 18.7679C24.3812 18.4107 23.6188 18.4107 23 18.7679L20 20.4999C19.3812 20.8572 19 21.5174 19 22.2319Z"
          stroke="#9C9EB6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const EyeButtonOpen = () => {
  return (
    <>
      <svg
        width="1.6rem"
        height="1.6rem"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.41452 6.58699C10.1952 7.36766 10.1952 8.63499 9.41452 9.41699C8.63386 10.1977 7.36652 10.1977 6.58452 9.41699C5.80386 8.63632 5.80386 7.36899 6.58452 6.58699C7.36652 5.80499 8.63319 5.80499 9.41452 6.58699"
          stroke="#72728F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 8.00016C2 7.56083 2.10133 7.12616 2.29733 6.7255V6.7255C3.30733 4.66083 5.53933 3.3335 8 3.3335C10.4607 3.3335 12.6927 4.66083 13.7027 6.7255V6.7255C13.8987 7.12616 14 7.56083 14 8.00016C14 8.4395 13.8987 8.87416 13.7027 9.27483V9.27483C12.6927 11.3395 10.4607 12.6668 8 12.6668C5.53933 12.6668 3.30733 11.3395 2.29733 9.27483V9.27483C2.10133 8.87416 2 8.4395 2 8.00016Z"
          stroke="#72728F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Checked = () => {
  return (
    <>
      <svg
        width="1.6rem"
        height="1.6rem"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="1.6rem" height="1.6rem" rx="2" fill="#27AE60" />
        <path
          d="M12 5.44531L6.88 10.5653L4 7.68531"
          stroke="white"
          strokeWidth="0.96"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Postpaid = () => {
  return (
    <>
      <svg
        width="1.8rem"
        height="1.8rem"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7544 13.502V9.00014C12.7545 8.60211 12.5964 8.22036 12.315 7.93891C12.0335 7.65747 11.6518 7.4994 11.2538 7.49951H3.75063C3.3526 7.4994 2.97085 7.65747 2.6894 7.93891C2.40796 8.22036 2.24989 8.60211 2.25 9.00014V13.502C2.24989 13.9 2.40796 14.2818 2.6894 14.5632C2.97085 14.8447 3.3526 15.0027 3.75063 15.0026H11.2538C12.0825 15.0026 12.7544 14.3308 12.7544 13.502Z"
          stroke="#72728F"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.25 10.56H12.7544"
          stroke="#72728F"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.65625 7.4995L5.56413 4.10808C5.66713 3.72373 5.91886 3.39616 6.26374 3.19768C6.60862 2.99919 7.01831 2.94611 7.40239 3.05014L14.6504 4.99345C15.0348 5.09646 15.3623 5.34818 15.5608 5.69307C15.7593 6.03795 15.8124 6.44764 15.7084 6.83172L14.5454 11.176C14.3384 11.9579 13.5471 12.4333 12.7596 12.249"
          stroke="#72728F"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const EditProfile = () => {
  return (
    <>
      <svg
        width="1.8rem"
        height="1.8rem"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.96975 11.7149L11.7143 3.97035C12.0068 3.67785 12.4815 3.67785 12.774 3.97035L14.031 5.22735C14.3235 5.51985 14.3235 5.9946 14.031 6.2871L6.28575 14.0309C6.1455 14.1719 5.955 14.2506 5.75625 14.2506H3.75V12.2444C3.75 12.0456 3.82875 11.8551 3.96975 11.7149Z"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3125 5.37012L12.63 7.68762"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Falsebutton = ({ size = "4rem" }) => {
  return (
    <div style={{ width: size, height: size }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="3.5"
          stroke="#DDE2FC"
        />
        <path
          d="M13.75 13.75L26.25 26.25"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.75 26.25L26.25 13.75"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
export const Tickbutton = ({ size = "4rem" }) => {
  return (
    <div style={{ width: size, height: size }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="3.5"
          stroke="#DDE2FC"
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.6904 15.4234C26.0624 15.7522 26.0972 16.321 25.7684 16.6954L18.8684 24.4954C18.7887 24.5855 18.6918 24.6587 18.5833 24.7107C18.4749 24.7627 18.3571 24.7925 18.2369 24.7982C18.1168 24.8039 17.9967 24.7854 17.8838 24.7439C17.7709 24.7025 17.6675 24.6388 17.5796 24.5566L13.0796 20.3566C12.9065 20.1935 12.805 19.9684 12.7973 19.7307C12.7897 19.4929 12.8764 19.2618 13.0387 19.0878C13.2009 18.9139 13.4254 18.8112 13.6631 18.8023C13.9008 18.7933 14.1324 18.8789 14.3072 19.0402L18.1352 22.6042L24.4232 15.5002C24.5016 15.4115 24.5967 15.3392 24.7031 15.2873C24.8095 15.2354 24.9251 15.2051 25.0433 15.1979C25.1614 15.1908 25.2798 15.207 25.3917 15.2457C25.5036 15.2844 25.6067 15.3448 25.6952 15.4234H25.6904Z"
          fill="#475CED"
        />
      </svg>
    </div>
  );
};
export const Tickbuttonfill = ({ size = "4rem" }) => {
  return (
    <div style={{ width: size, height: size }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" fill="#475CED" />

        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="3.5"
          stroke="#DDE2FC"
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.6943 15.4263C26.0663 15.7551 26.1011 16.3239 25.7723 16.6983L18.8723 24.4983C18.7926 24.5884 18.6957 24.6617 18.5872 24.7137C18.4788 24.7657 18.361 24.7954 18.2408 24.8011C18.1207 24.8068 18.0006 24.7884 17.8877 24.7469C17.7748 24.7054 17.6714 24.6417 17.5835 24.5595L13.0835 20.3595C12.9104 20.1964 12.8089 19.9714 12.8013 19.7336C12.7936 19.4958 12.8803 19.2647 13.0426 19.0908C13.2048 18.9168 13.4293 18.8141 13.667 18.8052C13.9047 18.7963 14.1363 18.8818 14.3111 19.0431L18.1391 22.6071L24.4271 15.5031C24.5055 15.4145 24.6006 15.3421 24.707 15.2902C24.8135 15.2384 24.929 15.208 25.0472 15.2009C25.1653 15.1937 25.2838 15.21 25.3956 15.2487C25.5075 15.2874 25.6106 15.3477 25.6991 15.4263H25.6943Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
export const UploadFile = () => {
  return (
    <>
      <svg
        width="3.2rem"
        height="3.2rem"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.0002 25.3333V16"
          stroke="#475CED"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1108 18.6657L16.0002 15.7764L18.8895 18.6657"
          stroke="#475CED"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.3341 25.3337H24.7474C27.3181 25.3337 29.4141 23.2377 29.4141 20.667C29.4141 18.0963 27.3181 16.0003 24.7474 16.0003H24.1674V14.667C24.1674 10.2537 20.5807 6.66699 16.1674 6.66699C12.1981 6.66699 8.9074 9.57099 8.2834 13.3643C5.11407 13.5257 2.5874 16.1243 2.5874 19.3337C2.5874 22.647 5.27407 25.3337 8.5874 25.3337H10.6674"
          stroke="#475CED"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Filterstatus = () => {
  return (
    <>
      <svg
        width="2.4rem"
        height="2.4rem"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 21H5C3.895 21 3 20.105 3 19V15C3 13.895 3.895 13 5 13H9C10.105 13 11 13.895 11 15V19C11 20.105 10.105 21 9 21Z"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 17H14C15.105 17 16 16.105 16 15V10C16 8.895 15.105 8 14 8H9C7.895 8 7 8.895 7 10V13"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 14H19C20.105 14 21 13.105 21 12V5C21 3.895 20.105 3 19 3H12C10.895 3 10 3.895 10 5V8"
          stroke="#475CED"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const FileIcon = () => {
  return (
    <>
      <svg
        width="1.6rem"
        height="1.6rem"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7474 11.9196L11.2522 13.4146C10.8771 13.7897 10.3684 14.0003 9.83798 14.0003L4.66638 14C4.13595 14 3.62726 13.7892 3.25221 13.4141C2.87716 13.039 2.66647 12.5303 2.6665 11.9999L2.66698 3.99988C2.66702 3.46945 2.87776 2.96075 3.25286 2.5857C3.62795 2.21065 4.13667 1.99997 4.6671 2L11.3338 2.0004C11.8642 2.00043 12.3729 2.21118 12.7479 2.58627C13.123 2.96137 13.3337 3.47009 13.3337 4.00052L13.3333 10.5054C13.3332 11.0359 13.1225 11.5446 12.7474 11.9196Z"
          stroke="#9C9EB6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3334 10.3331L11.0001 10.333C10.6464 10.333 10.3073 10.4734 10.0572 10.7235C9.80716 10.9735 9.66667 11.3126 9.66664 11.6663L9.6665 13.9996"
          stroke="#9C9EB6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6673 5.00049L5.33398 5.00017"
          stroke="#9C9EB6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33301 7.33317L10.6663 7.33349"
          stroke="#9C9EB6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.13301 9.66639L5.33301 9.66629"
          stroke="#9C9EB6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const TotalStock = () => {
  return (
    <>
      <svg
        width="2rem"
        height="2rem"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 17.5007H15"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 17.5007H5"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 17.5V10H5V17.5"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.3335 6.66667H11.6668"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 17.5006V6.66727C17.5 6.06227 17.1717 5.50393 16.6425 5.2106L10.8092 1.96977C10.3058 1.68977 9.69333 1.68977 9.19 1.96977L3.35667 5.2106C2.82833 5.50393 2.5 6.06227 2.5 6.66727V17.5006"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9442 17.5H10.555C10.2483 17.5 10 17.2517 10 16.9442V15.555C10 15.2483 10.2483 15 10.5558 15H11.945C12.2517 15 12.5 15.2483 12.5 15.5558V16.945C12.5 17.2517 12.2517 17.5 11.9442 17.5Z"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.44417 17.5H8.05583C7.74833 17.5 7.5 17.2517 7.5 16.9442V15.555C7.5 15.2483 7.74833 15 8.05583 15H9.445C9.75167 15 10 15.2483 10 15.5558V16.945C10 17.2517 9.75167 17.5 9.44417 17.5Z"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.694 14.9989H9.30486C8.99819 14.9989 8.74902 14.7505 8.74902 14.443V13.0539C8.74902 12.7472 8.99736 12.498 9.30486 12.498H10.694C11.0007 12.498 11.2499 12.7464 11.2499 13.0539V14.443C11.2499 14.7505 11.0015 14.9989 10.694 14.9989Z"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Free = () => {
  return (
    <>
      <svg
        width="2.1rem"
        height="2rem"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0036 12.6053V5.83082C17.0036 3.9891 15.5106 2.49609 13.6689 2.49609H6.16578C4.32406 2.49609 2.83105 3.9891 2.83105 5.83082V13.3339C2.83105 15.1757 4.32406 16.6687 6.16578 16.6687H12.9403"
          stroke="#9C9EB6"
          strokeWidth="1.29166"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1697 19.1694C14.328 19.1694 12.835 17.6764 12.835 15.8347C12.835 13.993 14.328 12.5 16.1697 12.5C18.0114 12.5 19.5044 13.993 19.5044 15.8347C19.5044 17.6764 18.0114 19.1694 16.1697 19.1694"
          stroke="#9C9EB6"
          strokeWidth="1.29166"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.22363 10.6554V8.51196C7.22382 8.23815 7.3717 7.98573 7.61046 7.85169L9.54627 6.7629C9.77702 6.63372 10.0583 6.63372 10.2891 6.7629L12.224 7.85169C12.4631 7.98547 12.611 8.23805 12.6109 8.51196V10.6554C12.6107 10.9292 12.4628 11.1816 12.224 11.3156L10.2874 12.3994C10.057 12.5286 9.77589 12.5286 9.54543 12.3994L7.60963 11.3148C7.37107 11.1811 7.22342 10.9288 7.22363 10.6554V10.6554Z"
          stroke="#9C9EB6"
          strokeWidth="1.29166"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.91733 9.58398V12.5019"
          stroke="#9C9EB6"
          strokeWidth="1.29166"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.32666 8.12891L9.91691 9.58285L12.508 8.12891"
          stroke="#9C9EB6"
          strokeWidth="1.29166"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.2807 15.2812L15.8918 16.671L15.0581 15.8373"
          stroke="#9C9EB6"
          strokeWidth="1.29166"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const Inuse = () => {
  return (
    <>
      <svg
        width="2.1rem"
        height="2rem"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.1665 5.83333V4.16667C3.1665 3.24619 3.9127 2.5 4.83317 2.5H6.49984"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1663 14.166V15.8327C18.1663 16.7532 17.4201 17.4993 16.4997 17.4993H14.833"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.84424 11.6667L7.67757 12.5L8.92757 11.25"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.41634 14.5827L6.08301 14.5826"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8333 10.8333H16.1296C16.6699 10.8333 17.188 10.6187 17.57 10.2367C17.9521 9.85468 18.1667 9.33655 18.1667 8.79629V4.53703C18.1667 3.99678 17.952 3.47865 17.57 3.09663C17.188 2.71461 16.6699 2.5 16.1296 2.5H11.037C10.4968 2.5 9.97865 2.71462 9.59663 3.09664C9.21461 3.47866 9 3.99679 9 4.53704V5.83333"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.958 2.5V4.58333C14.958 4.81345 14.7715 5 14.5413 5H12.6247C12.3946 5 12.208 4.81345 12.208 4.58333V2.5"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="3.1665"
          y="8.33398"
          width="9.16667"
          height="9.16667"
          rx="1.66667"
          stroke="#9C9EB6"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const PlanEdit = () => {
  return (
    <>
      <svg
        width="1.8rem"
        height="1.8rem"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.96975 11.7149L11.7143 3.97035C12.0068 3.67785 12.4815 3.67785 12.774 3.97035L14.031 5.22735C14.3235 5.51985 14.3235 5.9946 14.031 6.2871L6.28575 14.0309C6.1455 14.1719 5.955 14.2506 5.75625 14.2506H3.75V12.2444C3.75 12.0456 3.82875 11.8551 3.96975 11.7149Z"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3125 5.37012L12.63 7.68762"
          stroke="#475CED"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
